(function () {
    /* Это автоматически сгенеренный файл. Не редактируйте его самостоятельно. */
    var i18n = i18n || {};

    i18n['tanker'] = i18n['tanker'] || {};

    i18n['tanker']['dynamic'] = {
        gender: function (params) {
            return (function (params) {
                return params[params.gender];
            })(params);
        },
        plural: function (params) {
            return (function (params) {
                var count = isNaN(parseInt(params.count)) ? 0 : params.count;

                return count == 1 ? params.one : params.some;
            })(params);
        },
        plural_adv: function (params) {
            return (function (params) {
                var count = isNaN(parseInt(params.count)) ? 0 : params.count;

                if (count === 0) {
                    return params.none;
                }

                return i18n['tanker']['dynamic']['plural']({
                    count: params['count'],
                    one: params['one'],
                    some: params['some'],
                });
            })(params);
        },
        toggle: function (params) {
            return (function (params) {
                return Boolean(params.condition) ? params['true'] : params['false'];
            })(params);
        },
    };

    /* Это автоматически сгенеренный файл. Не редактируйте его самостоятельно. */
    var i18n = i18n || {};

    i18n['telemost'] = i18n['telemost'] || {};

    i18n['telemost']['broadcast-view'] = {
        'broadcast-start-countdown': function (params) {
            return 'The live stream starts in';
        },
        'broadcast-start-countdown-ended': function (params) {
            return 'The host will start the live stream soon';
        },
        'broadcast-start-date': function (params) {
            return params['date'] + ' at ' + params['time'];
        },
        'broadcast-start-date-title': function (params) {
            return 'The live stream starts';
        },
        'broadcast-stopped': function (params) {
            return 'Stream paused. The host will resume the live stream soon';
        },
        'created-by': function (params) {
            return 'Host: ' + params['name'];
        },
        'started-at': function (params) {
            return 'Stream started at ' + params['time'];
        },
        'viewers-count': function (params) {
            return params['count'] + ' current viewers';
        },
    };

    /* Это автоматически сгенеренный файл. Не редактируйте его самостоятельно. */
    var i18n = i18n || {};

    i18n['telemost'] = i18n['telemost'] || {};

    i18n['telemost']['call'] = {
        'additional-number-template': function (params) {
            return 'Ext. ' + params['number'];
        },
        'broadcast-link': function (params) {
            return 'Link to live stream';
        },
        'call-connecting': function (params) {
            return 'Connecting';
        },
        'call-into-meeting': function (params) {
            return 'Call into the meeting';
        },
        'copy-invitation': function (params) {
            return 'Copy invitation';
        },
        'invitation-copied': function (params) {
            return 'Invitation copied';
        },
        'invitation-header': function (params) {
            return 'Meeting in Yandex Telemost';
        },
        'invite-participants': function (params) {
            return 'Invite participants';
        },
        link: function (params) {
            return 'Link to video meeting';
        },
        'link-copied': function (params) {
            return 'Link copied';
        },
        'link-copied-on-start': function (params) {
            return 'Meeting link copied';
        },
        'link-successfully-copied': function (params) {
            return 'Link copied';
        },
        'meeting-link': function (params) {
            return 'Link to meeting';
        },
        'network-quality-status-bad-another': function (params) {
            return 'This participant has poor connection';
        },
        'network-quality-status-bad-self': function (params) {
            return 'You have poor connection';
        },
        'outgoing-call': function (params) {
            return 'Outgoing call';
        },
        'participant-video-limited': function (params) {
            return 'This user\nis subject to\nvideo restrictions.';
        },
        'participants-count': function (params) {
            return (
                params['count'] +
                ' ' +
                i18n['tanker']['dynamic']['plural']({
                    count: params['count'],
                    one: 'person',
                    some: 'people',
                    many: 'people',
                })
            );
        },
        'participants-list': function (params) {
            return 'Participants list';
        },
        'phone-invitation-header': function (params) {
            return 'Call into the Yandex Telemost meeting';
        },
        'phone-number-copied': function (params) {
            return 'Number copied';
        },
        'phone-template': function (params) {
            return params['phone'] + ', ext. ' + params['number'];
        },
        'share-link-copy-button': function (params) {
            return 'Copy link again';
        },
        'share-link-copy-button-on-blur': function (params) {
            return 'Copy link';
        },
        'share-link-copy-button-success': function (params) {
            return 'Link already copied';
        },
        'share-link-meeting-number': function (params) {
            return 'Meeting No. ' + params['number'];
        },
        'share-link-messenger': function (params) {
            return 'Send via Yandex Messenger';
        },
        'share-link-slack': function (params) {
            return 'Send via Slack';
        },
        'share-link-tg': function (params) {
            return 'Send via Telegram';
        },
        'share-link-title': function (params) {
            return 'To invite other participants,\nsend them the meeting link';
        },
        'share-link-whatsapp': function (params) {
            return 'Send via WhatsApp';
        },
        'sso-account-suggest': function (params) {
            return "It's best to join with your work account if you have one";
        },
        'video-limited-reason-network': function (params) {
            return 'No video due to poor connection';
        },
        'video-limited-reason-room-size': function (params) {
            return 'Video will appear when the participant speaks';
        },
        'video-limited-reason-self': function (params) {
            return "You hid participants' video streams";
        },
    };

    /* Это автоматически сгенеренный файл. Не редактируйте его самостоятельно. */
    var i18n = i18n || {};

    i18n['telemost'] = i18n['telemost'] || {};

    i18n['telemost']['chats'] = {
        broadcast_description: function (params) {
            return "The time is specified in the host's time zone. You can rename the chat. [Viewer link](%broadcast-uri%)";
        },
        broadcast_system_message: function (params) {
            return 'This is a general chat for viewers and organizers. To share the stream, send [this link](%broadcast-uri%)';
        },
        broadcast_title: function (params) {
            return 'Yandex Telemost live stream (chat created on %date%)';
        },
        noname_title: function (params) {
            return 'Yandex Telemost live stream';
        },
        nonpermanent_description: function (params) {
            return "The start of the meeting is specified in the organizer's time zone, [conference URL]((%conference-uri%)).";
        },
        nonpermanent_title: function (params) {
            return 'Meeting in Yandex Telemost on %date%';
        },
        permanent_description: function (params) {
            return "The time is specified in the organizer's time zone. You can rename the chat. [Conference URL](%conference-uri%).";
        },
        permanent_title: function (params) {
            return 'Meeting in Yandex Telemost (chat created on %date%)';
        },
        system_message: function (params) {
            return 'If you are logged in to Yandex, this chat will be saved to Yandex Messenger.';
        },
    };

    /* Это автоматически сгенеренный файл. Не редактируйте его самостоятельно. */
    var i18n = i18n || {};

    i18n['telemost'] = i18n['telemost'] || {};

    i18n['telemost']['cloud-recording'] = {
        'stop-modal-cancel': function (params) {
            return 'No';
        },
        'stop-modal-confirm': function (params) {
            return 'Yes';
        },
        'stop-modal-description': function (params) {
            return "Recording will stop for everyone. The link will appear in the chat and in the host's mailbox after processing. It'll take some time.";
        },
        'stop-modal-header': function (params) {
            return 'Stop recording to Yandex Disk?';
        },
    };

    /* Это автоматически сгенеренный файл. Не редактируйте его самостоятельно. */
    var i18n = i18n || {};

    i18n['telemost'] = i18n['telemost'] || {};

    i18n['telemost']['common'] = {
        admit: function (params) {
            return 'Let in';
        },
        'admit-all': function (params) {
            return 'Let everyone in';
        },
        'admit-to-limit': function (params) {
            return 'Let in up to the limit';
        },
        back: function (params) {
            return 'Back';
        },
        cancel: function (params) {
            return 'Cancel';
        },
        'change-account': function (params) {
            return 'Switch accounts';
        },
        'close-dialog': function (params) {
            return 'Close window';
        },
        continue: function (params) {
            return 'Continue';
        },
        'continue-in-browser': function (params) {
            return 'Continue in browser';
        },
        'copy-link': function (params) {
            return 'Copy link';
        },
        'copy-link-action': function (params) {
            return 'Copy link';
        },
        'copy-link-short': function (params) {
            return 'Copy';
        },
        'copy-link-to-conf': function (params) {
            return 'Copy meeting link';
        },
        'got-it': function (params) {
            return 'OK';
        },
        guest: function (params) {
            return 'Guest';
        },
        install: function (params) {
            return 'Install';
        },
        'install-app': function (params) {
            return 'Install app';
        },
        'install-app-v2': function (params) {
            return 'Desktop application';
        },
        'install-app-v3': function (params) {
            return 'Yandex Telemost for ' + params['osFamily'];
        },
        'install-app-v4': function (params) {
            return 'Скачать на ' + params['osFamily'];
        },
        'install-mobile-app': function (params) {
            return 'Mobile app';
        },
        'install-mobile-app-message': function (params) {
            return 'Download mobile app';
        },
        'install-mobile-app-v2': function (params) {
            return 'Yandex Telemost for mobile';
        },
        'install-mobile-app-v3': function (params) {
            return 'Скачать на телефон';
        },
        login: function (params) {
            return 'Log in';
        },
        logout: function (params) {
            return 'Log out';
        },
        name: function (params) {
            return 'Name';
        },
        'not-now': function (params) {
            return 'Not now';
        },
        ok: function (params) {
            return 'OK';
        },
        'open-in-app': function (params) {
            return 'Open in app';
        },
        'organizer-revoked-admit-permission': function (params) {
            return 'Организатор запретил впускать участников';
        },
        retry: function (params) {
            return 'Try again';
        },
        'retry-one-more-time': function (params) {
            return 'Try again';
        },
        'share-button-text': function (params) {
            return 'Invite to meeting';
        },
        'share-tooltip-text': function (params) {
            return 'Invite people to join the meeting';
        },
        support: function (params) {
            return 'Support';
        },
        'to-home': function (params) {
            return 'Home page';
        },
        'to-home-screen': function (params) {
            return 'Go to home screen';
        },
        'try-app': function (params) {
            return 'Try';
        },
        unwrap: function (params) {
            return 'Expand';
        },
        view: function (params) {
            return 'View';
        },
        wrap: function (params) {
            return 'Collapse';
        },
        'yandex-disk-title': function (params) {
            return 'Yandex Disk';
        },
    };

    /* Это автоматически сгенеренный файл. Не редактируйте его самостоятельно. */
    var i18n = i18n || {};

    i18n['telemost'] = i18n['telemost'] || {};

    i18n['telemost']['conferences-history'] = {
        'access-forbidden-contact-owner': function (params) {
            return 'Unavailable. Contact the meeting hosts.';
        },
        'access-forbidden-contact-support': function (params) {
            return 'Unavailable';
        },
        admins: function (params) {
            return 'Co-hosts';
        },
        'all-confs': function (params) {
            return 'All meetings';
        },
        'batch-fetching-failed': function (params) {
            return "Couldn't load some meetings. Try refreshing.";
        },
        'change-filters-hint': function (params) {
            return 'Try different filters';
        },
        'cloud-recording': function (params) {
            return 'Recorded to Yandex Disk';
        },
        'conf-number': function (params) {
            return 'Meeting number';
        },
        'conference-number': function (params) {
            return 'Meeting ' + params['id'];
        },
        'conferences-history': function (params) {
            return 'Meeting history';
        },
        'contact-support': function (params) {
            return 'Contact support';
        },
        'copy-email': function (params) {
            return 'Copy email';
        },
        day: function (params) {
            return '24 hours';
        },
        'email-copied': function (params) {
            return 'Email copied';
        },
        'empty-result-title': function (params) {
            return 'Past meetings will appear here';
        },
        'empty-result-title-active-filter': function (params) {
            return 'Meeting not found';
        },
        'fetching-error': function (params) {
            return "Couldn't load meeting list";
        },
        filter: function (params) {
            return 'Filter';
        },
        'for-3-month': function (params) {
            return 'Past 3 months';
        },
        home: function (params) {
            return 'Home page';
        },
        'in-progress': function (params) {
            return 'Processing';
        },
        'in-your-mail': function (params) {
            return 'In your inbox';
        },
        'insufficient-disk-space': function (params) {
            return "Can't upload the recording. Not enough space on your disk.";
        },
        'local-recording': function (params) {
            return 'Recorded to computer';
        },
        'meeting-report': function (params) {
            return 'Participation report';
        },
        members: function (params) {
            return 'Participants';
        },
        'members-recording': function (params) {
            return 'Recorded by participants';
        },
        month: function (params) {
            return 'Past month';
        },
        'no-artifacts': function (params) {
            return 'Without attachments';
        },
        other: function (params) {
            return "Couldn't create due to a technical issue";
        },
        'other-summarization': function (params) {
            return "Couldn't create due to a technical issue";
        },
        owner: function (params) {
            return 'Host';
        },
        period: function (params) {
            return 'Custom range';
        },
        recording: function (params) {
            return 'Recording';
        },
        'recording-too-short': function (params) {
            return "Couldn't create. The recording was shorter than 15 seconds.";
        },
        refresh: function (params) {
            return 'Refresh';
        },
        'report-error': function (params) {
            return "Couldn't create the report due to a technical issue";
        },
        'report-error-common': function (params) {
            return 'Report unavailable';
        },
        reset: function (params) {
            return 'Clear';
        },
        'reset-filters': function (params) {
            return 'Clear filters';
        },
        'select-conference': function (params) {
            return 'Select a meeting to view the details';
        },
        'send-to-email': function (params) {
            return 'Emailed to you';
        },
        'show-more-recipients': function (params) {
            return 'Show ' + params['count'] + ' more participants';
        },
        summarization: function (params) {
            return 'Summary';
        },
        'summarization-too-short': function (params) {
            return "Couldn't create. Summarization may have lasted less than 30 seconds, or everyone was silent. ";
        },
        today: function (params) {
            return 'today';
        },
        watch: function (params) {
            return 'Watch';
        },
        'who-receive': function (params) {
            return 'Received by';
        },
        'who-recording': function (params) {
            return 'Recorded by';
        },
        'with-recording': function (params) {
            return 'With a recording';
        },
        'with-report': function (params) {
            return 'With a participation report';
        },
        'with-summary': function (params) {
            return 'With a summary';
        },
    };

    /* Это автоматически сгенеренный файл. Не редактируйте его самостоятельно. */
    var i18n = i18n || {};

    i18n['telemost'] = i18n['telemost'] || {};

    i18n['telemost']['create-broadcast'] = {
        'access-level-organization': function (params) {
            return 'For employees';
        },
        'access-level-public': function (params) {
            return 'For everybody';
        },
        'broadcast-title-tooltip': function (params) {
            return 'Participants and viewers of the live stream will see the name';
        },
        'caption-placeholder': function (params) {
            return 'Name';
        },
        'caption-placeholder-v2': function (params) {
            return 'The name that the viewers will see';
        },
        'description-placeholder': function (params) {
            return 'Description';
        },
        'form-title': function (params) {
            return 'New live stream';
        },
        'start-button': function (params) {
            return 'Create stream now';
        },
        'start-button-short': function (params) {
            return 'Create now';
        },
    };

    /* Это автоматически сгенеренный файл. Не редактируйте его самостоятельно. */
    var i18n = i18n || {};

    i18n['telemost'] = i18n['telemost'] || {};

    i18n['telemost']['create-call'] = {
        'app-description': function (params) {
            return 'Create a video meeting\nand send an invite link\nto friends and colleagues.';
        },
        'broadcast-description': function (params) {
            return 'A separate link for viewers, only participants can join a video meeting';
        },
        'broadcast-text': function (params) {
            return 'New live stream';
        },
        connect: function (params) {
            return 'Join meeting';
        },
        'connect-call-description': function (params) {
            return 'By link or\nmeeting number';
        },
        'connect-call-text': function (params) {
            return 'Join meeting';
        },
        'create-call-text': function (params) {
            return 'Create video meeting';
        },
        'disabled-broadcast-description': function (params) {
            return 'Unavailable in your plan';
        },
        'disabled-broadcast-description-more': function (params) {
            return 'Learn more';
        },
        'insert-link-or-meeting-number': function (params) {
            return 'Enter the meeting number or link';
        },
        'insert-link-or-meeting-number-notification': function (params) {
            return 'Enter the meeting number or link';
        },
        'install-button-tooltip': function (params) {
            return 'Even easier with the app';
        },
        'main-title': function (params) {
            return 'Yandex Telemost — click-and-join video conferencing';
        },
        'main-title-v2': function (params) {
            return 'Yandex Telemost —\nchats and video calls';
        },
        'new-call-description': function (params) {
            return 'It starts immediately, share the link with participants';
        },
        'new-call-text': function (params) {
            return 'New video meeting';
        },
        ok: function (params) {
            return 'OK';
        },
        'plan-call-description': function (params) {
            return 'The event with the meeting link will be added to your Yandex Calendar';
        },
        'plan-call-text': function (params) {
            return 'Schedule';
        },
    };

    /* Это автоматически сгенеренный файл. Не редактируйте его самостоятельно. */
    var i18n = i18n || {};

    i18n['telemost'] = i18n['telemost'] || {};

    i18n['telemost']['dtmf'] = {
        'command-list.audio.mute': function (params) {
            return 'Mute microphone';
        },
        'command-list.audio.unmute': function (params) {
            return 'Unmute microphone';
        },
        'command-list.gallery-view.turn-on': function (params) {
            return 'Turn on gallery view';
        },
        'command-list.participant-list.open': function (params) {
            return 'Participants list';
        },
        'command-list.participant-list.show': function (params) {
            return 'Show participant list';
        },
        'command-list.presenter-view.turn-on': function (params) {
            return 'Turn on speaker view';
        },
        'command-list.reactions.hand-down': function (params) {
            return 'Hand down';
        },
        'command-list.reactions.hand-up': function (params) {
            return 'Raise hand';
        },
        'command-list.subtitle': function (params) {
            return "Tap the desired symbol on your tablet's keyboard";
        },
        'command-list.title': function (params) {
            return 'Commands list';
        },
        'command-list.video.mute': function (params) {
            return 'Turn off camera';
        },
        'command-list.video.unmute': function (params) {
            return 'Turn on camera';
        },
        'common.close': function (params) {
            return 'Close';
        },
        'gallery-view': function (params) {
            return 'Gallery view';
        },
        'notification.camera-and-microphone-muted': function (params) {
            return 'Camera and microphone are off.';
        },
        'notification.camera-muted': function (params) {
            return 'Camera is off.';
        },
        'notification.hand-lower': function (params) {
            return 'Lower hand';
        },
        'notification.hand-raised': function (params) {
            return 'Hand raised.';
        },
        'notification.microphone-muted': function (params) {
            return 'Microphone is off.';
        },
        'notification.recording': function (params) {
            return 'Recording';
        },
        'notification.summarization': function (params) {
            return 'Summarizing';
        },
        'notification.turn-on': function (params) {
            return 'Turn on';
        },
        'notification.turn-on-camera': function (params) {
            return 'Turn on camera';
        },
        'notification.turn-on-microphone': function (params) {
            return 'Turn on microphone';
        },
        'notification.waiting-room': function (params) {
            return 'There are participants in the waiting room';
        },
        'pagination-next-page': function (params) {
            return 'Participants gallery: scroll right';
        },
        'pagination-prev-page': function (params) {
            return 'Participants gallery: scroll left';
        },
        'participant-list.count': function (params) {
            return (
                params['count'] +
                ' ' +
                i18n['tanker']['dynamic']['plural']({
                    count: params['count'],
                    one: 'participant',
                    some: 'participants',
                    many: 'participants',
                })
            );
        },
        'participant-list.next-page': function (params) {
            return 'Next page';
        },
        'participant-list.page-state': function (params) {
            return params['currentPage'] + ' out of ' + params['totalPages'];
        },
        'participant-list.prev-page': function (params) {
            return 'Previous page';
        },
        'presenter-view': function (params) {
            return 'Speaker view';
        },
        'unmute-notification.both-camera-text': function (params) {
            return 'Turn on the camera';
        },
        'unmute-notification.both-common-text': function (params) {
            return 'The camera and microphone are off.';
        },
        'unmute-notification.both-microphone-text': function (params) {
            return 'Turn on the microphone';
        },
        'unmute-notification.camera-text': function (params) {
            return 'The camera is off. Turn on';
        },
        'unmute-notification.microphone-text': function (params) {
            return 'The microphone is off. Turn on';
        },
        'unmute-notification.text': function (params) {
            return 'The microphone in the meeting room is muted. To unmute it, press the sequence of symbols.';
        },
    };

    /* Это автоматически сгенеренный файл. Не редактируйте его самостоятельно. */
    var i18n = i18n || {};

    i18n['telemost'] = i18n['telemost'] || {};

    i18n['telemost']['error-page'] = {
        'ask-for-camera-and-mic-permissions': function (params) {
            return 'Allow access\nto the camera and microphone';
        },
        'back-to-chats': function (params) {
            return 'Back to chats';
        },
        'broadcast-gone': function (params) {
            return 'This stream has ended';
        },
        'broadcast-gone-v2': function (params) {
            return 'This live stream has ended';
        },
        'broadcast-gone-v2-with-datetime': function (params) {
            return 'This live stream ended\non ' + params['date'] + ' at ' + params['time'] + ' ';
        },
        'broadcast-not-found': function (params) {
            return "Couldn't find stream";
        },
        'broadcast-organization-mismatches-description': function (params) {
            return "Only company employees can join this live stream. Make sure you're using the correct account.";
        },
        'broadcast-organization-mismatches-title': function (params) {
            return 'This is a private live stream';
        },
        'broadcast-organization-mismatches-unauthorized-description': function (params) {
            return 'Only company employees can join this live stream. ';
        },
        'close-button-title': function (params) {
            return 'Close';
        },
        'default-title': function (params) {
            return 'An error occurred';
        },
        'forbidden-title': function (params) {
            return 'Access denied';
        },
        'gone-title': function (params) {
            return 'This meeting already ended,\nbut you can create a new one';
        },
        'how-to-add-permission-link': function (params) {
            return 'Instructions';
        },
        'no-camera-and-mic-permissions': function (params) {
            return 'No access to camera and microphone';
        },
        'no-device-permission-text': function (params) {
            return 'Video calls are unavailable.\nAllow access to the camera and microphone.';
        },
        'not-found-title': function (params) {
            return "That meeting doesn't exist,\nbut you can create a new one";
        },
        'not-in-experiment-title': function (params) {
            return "You can't create meetings yet,\nbut you can join them if you're invited";
        },
        'not-started-title': function (params) {
            return (
                "The meeting hasn't started yet. It will start on " +
                params['date'] +
                ' at ' +
                params['time'] +
                '. You can join at ' +
                params['startTime'] +
                '.'
            );
        },
        'organization-mismatches-description': function (params) {
            return "Only company employees can join this meeting. Make sure you're using the correct account.";
        },
        'organization-mismatches-title': function (params) {
            return 'This is a private meeting';
        },
        'organization-mismatches-unauthorized-button': function (params) {
            return 'Log in';
        },
        'organization-mismatches-unauthorized-description': function (params) {
            return 'Only company employees can join this meeting.';
        },
        'organization-mismatches-yateam-button-primary': function (params) {
            return 'Change account';
        },
        'organization-mismatches-yateam-button-secondary': function (params) {
            return 'Go to app';
        },
        'organization-mismatches-yateam-description': function (params) {
            return 'Or try to go to the app.\nYou are not able to get into a working meeting with a personal account';
        },
        'organization-mismatches-yateam-title': function (params) {
            return 'Change your account to @yandex-team.ru';
        },
        'overloaded-title': function (params) {
            return "The service is currently overloaded, but we're already working on it.";
        },
        'try-calls-in-disk': function (params) {
            return 'Try \n video meetings in Yandex Disk';
        },
        'try-telemost-app': function (params) {
            return 'Try the \n Telemost app';
        },
        'unauthorized-subtitle': function (params) {
            return 'To create a meeting,\nlog in to your Yandex account';
        },
        'unauthorized-title': function (params) {
            return 'Click-and-join video conferencing';
        },
        'unsupported-browser-subtitle': function (params) {
            return 'Install the <x-link-disk>Yandex Disk</x-link-disk> for Desktop app<x-link-yabro>or use <x-link-yabro>Yandex Browser</x-link-yabro>, Google Chrome, or Mozilla Firefox';
        },
        'unsupported-browser-subtitle-no-ff': function (params) {
            return (
                'Install the desktop app\nor use ' +
                '<x-link-yabro>' +
                'Yandex Browser' +
                '</x-link-yabro>' +
                ' or Google Chrome'
            );
        },
        'unsupported-browser-subtitle2': function (params) {
            return (
                'Install the desktop app\nor use ' +
                '<x-link-yabro>' +
                'Yandex Browser' +
                '</x-link-yabro>' +
                ', Google Chrome, or Mozilla Firefox'
            );
        },
        'unsupported-browser-subtitle2-no-desktop': function (params) {
            return (
                'Use ' + '<x-link-yabro>' + 'Yandex Browser' + '</x-link-yabro>' + ', Google Chrome, or Mozilla Firefox'
            );
        },
        'unsupported-electron': function (params) {
            return 'This version of Yandex Telemost is outdated: it no longer supports video meetings. Download the new stand-alone Yandex Telemost program.';
        },
        'unsupported-electron-button': function (params) {
            return 'Download';
        },
        'unsupported-messenger-description': function (params) {
            return 'Update or reinstall the app. ' + '<x-link-help>' + 'How do I do that?' + '</x-link-help>';
        },
        'unsupported-messenger-title': function (params) {
            return 'To use calls, you need\nthe latest Yandex Messenger version';
        },
        'unsupported-mobile-bro-videocalls': function (params) {
            return 'Video meetings are not yet available\nin mobile browsers.';
        },
        'unsupported-mobile-browser': function (params) {
            return 'Mobile browsers \n are currently unsupported.';
        },
        'user-kicked-description': function (params) {
            return 'Try joining it again later.';
        },
        'user-kicked-title': function (params) {
            return 'You were removed from this meeting';
        },
        'user-kicked-with-ban-description': function (params) {
            return 'Try joining again after 24 hours.';
        },
        'usupported-browser-title': function (params) {
            return "Your browser\ndoesn't support Telemost";
        },
    };

    /* Это автоматически сгенеренный файл. Не редактируйте его самостоятельно. */
    var i18n = i18n || {};

    i18n['telemost'] = i18n['telemost'] || {};

    i18n['telemost']['faq'] = {
        'answer-1': function (params) {
            return 'Yandex Telemost is a click-and-join video conferencing platform. In Yandex Telemost, you can organize business meetings, family get-togethers, and even online parties. Just create a meeting and share the link with your friends or colleagues.';
        },
        'answer-2': function (params) {
            return (
                'Your meetings are limited to 40 participants when you use Yandex Telemost for free. For meetings with up to 1000 participants, upgrade to a ' +
                '<x-link-payment-plans>' +
                'business plan' +
                '</x-link-payment-plans>' +
                '.'
            );
        },
        'answer-3': function (params) {
            return "Video meetings in Yandex Telemost have no time limits: there won't be any sudden interruptions during an important discussion.";
        },
        'answer-4': function (params) {
            return (
                'Yes, you can. To use Yandex Telemost for commercial purposes, register your company in Yandex 360 for Business. ' +
                '<x-link-business>' +
                'Learn more ' +
                '</x-link-business>' +
                '\n'
            );
        },
        'answer-5': function (params) {
            return 'Go to the Yandex Telemost page or open the Yandex Telemost program and click "Schedule". Enter the meeting date and time, add participants, and click "Create": the meeting will appear in your Yandex Calendar. You can also schedule a video meeting from Yandex Calendar itself: create an event in Yandex Calendar in the usual way and click "Add video meeting" in its settings.';
        },
        'answer-6': function (params) {
            return "Virtual backgrounds are currently only available in the Yandex Telemost desktop application. You can't set up a background in the web version. If your application doesn't have this setting, your processor might not support virtual backgrounds.";
        },
        'question-1': function (params) {
            return ' What is Yandex Telemost?';
        },
        'question-2': function (params) {
            return 'How many people can attend a video meeting?';
        },
        'question-3': function (params) {
            return 'How long can meetings last?';
        },
        'question-4': function (params) {
            return 'Can I use Yandex Telemost for business or commercial purposes?';
        },
        'question-5': function (params) {
            return 'How do I schedule a meeting in advance?';
        },
        'question-6': function (params) {
            return "Why can't I set up a virtual background in Yandex Telemost?";
        },
        title: function (params) {
            return 'Frequently asked questions';
        },
    };

    /* Это автоматически сгенеренный файл. Не редактируйте его самостоятельно. */
    var i18n = i18n || {};

    i18n['telemost'] = i18n['telemost'] || {};

    i18n['telemost']['feedback'] = {
        cancel: function (params) {
            return 'No rating';
        },
        comment: function (params) {
            return 'Comment';
        },
        'contact-support': function (params) {
            return 'Contact support';
        },
        'feedback-description-hint': function (params) {
            return 'Please provide a detailed description of the problem — what actions did you take and what was the outcome?';
        },
        'feedback-email-hint': function (params) {
            return 'Provide your email address so we can get back to you';
        },
        'feedback-form-header': function (params) {
            return 'Rate the call quality';
        },
        message: function (params) {
            return 'Rate the quality\nof this meeting';
        },
        'message-placeholder': function (params) {
            return 'Tell us what happened';
        },
        rate: function (params) {
            return 'Rate';
        },
        'reason-bad-audio': function (params) {
            return 'Bad audio';
        },
        'reason-bad-video': function (params) {
            return 'Bad video';
        },
        'reason-disconnect': function (params) {
            return 'Meeting was disconnected ';
        },
        'reason-echo': function (params) {
            return 'Echo or background noise';
        },
        'reason-no-audio': function (params) {
            return "Couldn't hear me or others";
        },
        'reason-no-video': function (params) {
            return "Couldn't see me or others";
        },
        'reason-title': function (params) {
            return "What didn't\nyou like?";
        },
        reason_audio_desync: function (params) {
            return 'Audio is out of sync';
        },
        reason_audio_distorted: function (params) {
            return 'Distortions or glitches';
        },
        reason_audio_echo: function (params) {
            return 'Echo';
        },
        'reason_audio_no-data': function (params) {
            return 'No sound for me or other person';
        },
        reason_audio_noise: function (params) {
            return 'Background noise';
        },
        reason_audio_volume: function (params) {
            return 'Too loud or quiet';
        },
        reason_group_audio: function (params) {
            return 'Sound';
        },
        reason_group_sharing: function (params) {
            return 'Screen share';
        },
        reason_group_video: function (params) {
            return 'Video';
        },
        reason_sharing_distorted: function (params) {
            return 'Distorted';
        },
        'reason_sharing_no-data': function (params) {
            return "Won't start";
        },
        reason_video_distorted: function (params) {
            return 'Distorted';
        },
        reason_video_freezing: function (params) {
            return 'Freezes';
        },
        'reason_video_no-data': function (params) {
            return "Couldn't see me or other person";
        },
        'report-a-problem-button': function (params) {
            return 'Report a problem';
        },
        'report-a-problem-form-header': function (params) {
            return 'Problem report';
        },
        'send-feedback-error': function (params) {
            return "Couldn't send message.\nPlease try again.";
        },
        'star-rate': function (params) {
            return 'Select ' + params['index'] + ' out of ' + params['count'] + ' stars';
        },
        submit: function (params) {
            return 'Submit';
        },
        'success-send-notification': function (params) {
            return 'Thank you, your report will help improve Yandex Telemost';
        },
        'success-send-notification-v2': function (params) {
            return 'Thank you! Your rating has been recorded.';
        },
        title: function (params) {
            return 'You left the meeting';
        },
    };

    /* Это автоматически сгенеренный файл. Не редактируйте его самостоятельно. */
    var i18n = i18n || {};

    i18n['telemost'] = i18n['telemost'] || {};

    i18n['telemost']['footer'] = {
        disclaimer: function (params) {
            return 'By using Yandex Telemost, you agree to the terms and conditions of the';
        },
        'terms-of-use': function (params) {
            return 'User Agreement';
        },
    };

    /* Это автоматически сгенеренный файл. Не редактируйте его самостоятельно. */
    var i18n = i18n || {};

    i18n['telemost'] = i18n['telemost'] || {};

    i18n['telemost']['header'] = {
        'app-description': function (params) {
            return 'Free video calls and meetings right in your browser. No sign-up required. Join easily from computer or phone. For work, school, and everyday calls.';
        },
        'app-join-description': function (params) {
            return 'Join and talk with no time limits';
        },
        'app-join-og-description': function (params) {
            return 'Use this link to join the call\n';
        },
        'app-telemessenger-chat-og-description': function (params) {
            return 'Use this link to join the chat\n';
        },
        'app-telemessenger-description': function (params) {
            return 'Use our messenger for chats and video calls with no time limits';
        },
        'app-telemessenger-invite-og-description': function (params) {
            return 'This link opens a private chat\n';
        },
        'join-og-title': function (params) {
            return 'Call in Yandex Telemost\n';
        },
        'join-title': function (params) {
            return 'Call in Yandex Telemost ';
        },
        logout: function (params) {
            return 'Log out';
        },
        'premium-button-text': function (params) {
            return 'For business';
        },
        'premium-button-text-v2': function (params) {
            return 'Plans for corporate clients';
        },
        'telemessenger-chat-og-title': function (params) {
            return 'Chat in Yandex Telemost\n';
        },
        'telemessenger-invite-og-title': function (params) {
            return 'Join me in Yandex Telemost\n';
        },
        'telemessenger-title': function (params) {
            return 'Chat in Yandex Telemost';
        },
        title: function (params) {
            return 'Yandex Telemost — free video meetings with no sign-up and no time limits';
        },
    };

    /* Это автоматически сгенеренный файл. Не редактируйте его самостоятельно. */
    var i18n = i18n || {};

    i18n['telemost'] = i18n['telemost'] || {};

    i18n['telemost']['lists'] = {
        'months-genitive': function (params) {
            return 'January | February | March | April | May | June | July | August | September | October | November | December';
        },
        'months-nominative': function (params) {
            return 'January | February | March | April | May | June | July | August | September | October | November | December';
        },
        'week-days': function (params) {
            return 'sunday | monday | tuesday | wednesday | thursday | friday | saturday | sunday';
        },
    };

    /* Это автоматически сгенеренный файл. Не редактируйте его самостоятельно. */
    var i18n = i18n || {};

    i18n['telemost'] = i18n['telemost'] || {};

    i18n['telemost']['moderation'] = {
        'access-level-organization': function (params) {
            return 'For employees only';
        },
        'access-level-public': function (params) {
            return 'For all users';
        },
        'access-level-waiting-room-admins': function (params) {
            return 'Waiting room for all users';
        },
        'access-level-waiting-room-organization': function (params) {
            return 'Waiting room for external users';
        },
        'access-level-waiting-room-public': function (params) {
            return 'Waiting room off';
        },
        'action-change-avatar': function (params) {
            return 'Change image';
        },
        'action-change-name-and-avatar': function (params) {
            return 'Change name and image';
        },
        'action-kick-user': function (params) {
            return 'Remove from meeting';
        },
        'action-make-an-co-host': function (params) {
            return 'Make co-host';
        },
        'action-make-an-co-host-v2': function (params) {
            return 'Сделать соорганизатором';
        },
        'action-make-an-moderator': function (params) {
            return 'Make admin';
        },
        'action-mute-all-audio': function (params) {
            return 'Mute everyone';
        },
        'action-mute-all-reactions-hand': function (params) {
            return 'All hands down';
        },
        'action-mute-all-video': function (params) {
            return "Turn off everyone's camera";
        },
        'action-mute-reaction-hand': function (params) {
            return 'Hand down';
        },
        'action-mute-screensharing': function (params) {
            return 'Stop sharing';
        },
        'action-mute-video': function (params) {
            return 'Turn off camera';
        },
        'action-stop-all-local-recordings': function (params) {
            return 'Остановить все записи на компьютер';
        },
        'action-stop-local-recording': function (params) {
            return 'Остановить запись на компьютер';
        },
        'action-unmake-an-co-host': function (params) {
            return 'Забрать права соорганизатора';
        },
        'co-host': function (params) {
            return 'co-host';
        },
        host: function (params) {
            return 'host';
        },
        'modal-confirm-access-level-limit-text': function (params) {
            return 'There are more employees in the waiting room than the meeting can accommodate';
        },
        'modal-confirm-access-level-limit-title': function (params) {
            return "Some employees won't be able to join the meeting";
        },
        'modal-confirm-end-call-button-confirm': function (params) {
            return 'End';
        },
        'modal-confirm-end-call-content': function (params) {
            return "The participants won't be able to stay and continue the conversation";
        },
        'modal-confirm-end-call-header': function (params) {
            return 'End the meeting for everyone?';
        },
        'modal-confirm-end-call-with-broadcast-content': function (params) {
            return 'The live stream will also end';
        },
        'modal-kick-confirm-button-cancel': function (params) {
            return 'Cancel';
        },
        'modal-kick-confirm-button-confirm': function (params) {
            return 'Delete';
        },
        'modal-kick-confirm-checkbox-label': function (params) {
            return 'Close access for 24 hours';
        },
        'modal-kick-confirm-text': function (params) {
            return 'After deleting, ' + params['name'] + ' will be able to join this meeting again.';
        },
        'modal-kick-confirm-text-open': function (params) {
            return (
                'After deleting ' +
                params['name'] +
                ' will be able to join this meeting again — it is open to everyone.'
            );
        },
        'modal-kick-confirm-text-open-ban': function (params) {
            return 'To restrict access and block users at a meeting, change the access type in the list of participants.';
        },
        'modal-kick-confirm-title': function (params) {
            return 'Delete from a meeting?';
        },
        'modal-stop-all-recordings-description': function (params) {
            return 'Записанное сохранится на компьютерах участников';
        },
        'modal-stop-all-recordings-with-removal-label': function (params) {
            return 'Удалить записи';
        },
        'modal-stop-recording-cancel-label': function (params) {
            return 'Не останавливать';
        },
        'modal-stop-recording-confirm-label': function (params) {
            return 'Остановить';
        },
        'modal-stop-recording-description': function (params) {
            return 'Записанное сохранится на компьютере участника';
        },
        'modal-stop-recording-header': function (params) {
            return 'Остановить запись?';
        },
        'modal-stop-recording-with-removal-label': function (params) {
            return 'Удалить запись';
        },
        'modal-stop-recordings-header': function (params) {
            return 'Остановить записи?';
        },
        'notification-action-error': function (params) {
            return 'Something went wrong. Please try again';
        },
        'notification-action-error-kick': function (params) {
            return 'The participant could not be deleted. Please try again';
        },
        'notification-action-error-make-an-co-host': function (params) {
            return "Couldn't make the participant the co-host. Try again.";
        },
        'notification-action-error-mute-all-audio': function (params) {
            return "Couldn't mute everyone. Please try again";
        },
        'notification-action-error-mute-all-recordings': function (params) {
            return 'Не удалось остановить записи';
        },
        'notification-action-error-mute-all-video': function (params) {
            return "Couldn't turn off everyone's camera. Please try again";
        },
        'notification-action-error-mute-audio': function (params) {
            return "Couldn't mute the participant. Please try again";
        },
        'notification-action-error-mute-recording': function (params) {
            return params['name'] + ' всё ещё записывает встречу — не удалось остановить';
        },
        'notification-action-error-mute-recordings-no-permission': function (params) {
            return 'Организатор запретил останавливать чужие записи';
        },
        'notification-action-error-mute-screensharing': function (params) {
            return "Couldn't turn off screen sharing for the participant. Please try again";
        },
        'notification-action-error-mute-video': function (params) {
            return "Couldn't turn off the participant's camera. Please try again";
        },
        'notification-action-error-permissions': function (params) {
            return 'Failed to change member permissions';
        },
        'notification-action-error-set-broadcast-access-level': function (params) {
            return 'The broadcast availability could not be changed. Try again';
        },
        'notification-action-error-set-conference-access-level': function (params) {
            return 'The meeting availability could not be changed. Try again';
        },
        'notification-action-success-mute-all-recordings': function (params) {
            return 'Встречу больше не записывают. Записанное удалится';
        },
        'notification-action-success-mute-all-recordings-without-removal': function (params) {
            return 'Встречу больше не записывают';
        },
        'notification-action-success-mute-recording': function (params) {
            return params['name'] + ' больше не записывает встречу. Записанное удалится';
        },
        'notification-action-success-mute-recording-without-removal': function (params) {
            return params['name'] + ' больше не записывает встречу';
        },
        'notification-confirm-ban-recording-content': function (params) {
            return "The recording you started won't be saved";
        },
        'notification-confirm-ban-recording-header': function (params) {
            return 'The host has disabled recording for this meeting';
        },
        'notification-confirm-mute-recording-content': function (params) {
            return 'Записанное не сохранится';
        },
        'notification-confirm-mute-recording-header': function (params) {
            return 'Вашу запись остановили';
        },
        'notification-confirm-mute-recording-without-removal-content': function (params) {
            return 'Записанное сохранится на компьютере';
        },
        'notification-iam-new-co-host': function (params) {
            return params['name'] + ' made you the meeting co-host';
        },
        'notification-iam-not-co-host': function (params) {
            return "You're no longer the co-host of this meeting";
        },
        'notification-iam-not-co-host-v2': function (params) {
            return 'Организатор забрал у вас права соорганизатора';
        },
        'notification-kick': function (params) {
            return 'You have removed a participant from the meeting ' + params['name'];
        },
        'notification-kick-with-ban': function (params) {
            return 'You have removed a participant from the meeting ' + params['name'] + ' for 24 hours';
        },
        'notification-make-admin-error': function (params) {
            return params['name'] + ' пока не соорганизатор — не удалось дать права';
        },
        'notification-make-member-error': function (params) {
            return params['name'] + ' всё ещё соорганизатор — не удалось забрать права ';
        },
        'notification-my-audio-was-muted-by-co-host': function (params) {
            return 'The co-host muted you';
        },
        'notification-my-audio-was-muted-by-host': function (params) {
            return 'The host muted you';
        },
        'notification-my-recording-was-muted-by': function (params) {
            return params['name'] + ' остановил(а) вашу запись на компьютер';
        },
        'notification-my-screensharing-was-muted-by-co-host': function (params) {
            return 'Screen sharing stopped by co-host';
        },
        'notification-my-screensharing-was-muted-by-host': function (params) {
            return 'Screen sharing stopped by host';
        },
        'notification-my-video-was-muted-by-co-host': function (params) {
            return 'Camera turned off by co-host';
        },
        'notification-my-video-was-muted-by-host': function (params) {
            return 'Camera turned off by the host';
        },
        'notification-new-co-host': function (params) {
            return params['name'] + ' is now the meeting co-host';
        },
        'notification-no-longer-co-host': function (params) {
            return params['name'] + ' is no longer the co-host of this meeting';
        },
        'notification-no-longer-co-host-v2': function (params) {
            return params['name'] + ' больше не соорганизатор';
        },
        'organizer-revoked-access-level-edit-permission': function (params) {
            return 'Организатор запретил настраивать комнату ожидания';
        },
    };

    /* Это автоматически сгенеренный файл. Не редактируйте его самостоятельно. */
    var i18n = i18n || {};

    i18n['telemost'] = i18n['telemost'] || {};

    i18n['telemost']['native-app-banner'] = {
        'app-description': function (params) {
            return 'Open or download the app';
        },
        'app-link': function (params) {
            return 'Link to the app';
        },
        'app-name': function (params) {
            return 'Yandex Telemost';
        },
        'app-open-button': function (params) {
            return 'DOWNLOAD';
        },
        description: function (params) {
            return 'Message and call your phone contacts';
        },
        'description-v2': function (params) {
            return 'For calls and chats';
        },
        download: function (params) {
            return 'Download';
        },
        'download-telemost': function (params) {
            return 'Download Yandex Telemost ';
        },
        'telemost-has-chats': function (params) {
            return 'The Yandex Telemost app supports chats';
        },
        title: function (params) {
            return 'The app supports chats';
        },
        'title-v2': function (params) {
            return 'Mobile app';
        },
    };

    /* Это автоматически сгенеренный файл. Не редактируйте его самостоятельно. */
    var i18n = i18n || {};

    i18n['telemost'] = i18n['telemost'] || {};

    i18n['telemost']['native-app-modal'] = {
        description: function (params) {
            return 'Chats and calls with no restrictions. Stay in touch with colleagues and family.\n';
        },
        title: function (params) {
            return 'Yandex Telemost mobile app';
        },
    };

    /* Это автоматически сгенеренный файл. Не редактируйте его самостоятельно. */
    var i18n = i18n || {};

    i18n['telemost'] = i18n['telemost'] || {};

    i18n['telemost']['new-call'] = {
        'go-on': function (params) {
            return 'Switch';
        },
        'modal-title': function (params) {
            return 'You are already in a meet.' + params['spacebreak'] + 'Would you like to switch to another?';
        },
        'not-now': function (params) {
            return 'Not now';
        },
    };

    /* Это автоматически сгенеренный файл. Не редактируйте его самостоятельно. */
    var i18n = i18n || {};

    i18n['telemost'] = i18n['telemost'] || {};

    i18n['telemost']['overlay'] = {
        'ask-for-introduction': function (params) {
            return 'Enter your name';
        },
        'connect-call-button': function (params) {
            return 'Join meeting';
        },
        'join-broadcast-button': function (params) {
            return 'Join live stream';
        },
        'join-button': function (params) {
            return 'Join meeting';
        },
        'join-created-broadcast-description': function (params) {
            return 'Only participants will see you. Check your video and sound.';
        },
        'join-created-broadcast-title': function (params) {
            return 'Ready to join?';
        },
        'join-started-broadcast-description': function (params) {
            return 'All viewers of the live stream will see you Check your video and sound.';
        },
        'join-started-broadcast-title': function (params) {
            return 'Ready to join?';
        },
        'nickname-title-label': function (params) {
            return 'Nickname';
        },
        'no-fitting-account': function (params) {
            return 'Нет нужного аккаунта';
        },
        'quality-message': function (params) {
            return 'The meeting will take place in the browser: this way, the quality of video and audio will be better';
        },
        'select-account': function (params) {
            return 'Выберите аккаунт';
        },
        'to-home-screen': function (params) {
            return 'На главную';
        },
        'waiting-room-status-1': function (params) {
            return 'You are in the waiting room...';
        },
        'waiting-room-status-2': function (params) {
            return 'The host has received your request to join...';
        },
        'you-are-joining-text': function (params) {
            return (
                'You are joining' +
                params['spacebreak'] +
                'a video meeting' +
                i18n['tanker']['dynamic']['toggle']({
                    condition: params['showTail'],
                    true: ",\ndon't forget to introduce yourself",
                    false: '',
                }) +
                '\n'
            );
        },
    };

    /* Это автоматически сгенеренный файл. Не редактируйте его самостоятельно. */
    var i18n = i18n || {};

    i18n['telemost'] = i18n['telemost'] || {};

    i18n['telemost']['participants-sidebar'] = {
        'cloud-recording-in-progress': function (params) {
            return 'Recording to Yandex Disk';
        },
        'cloud-recording-member-tip': function (params) {
            return 'Find the link in the meeting chat';
        },
        'cloud-recording-member-tip-v2': function (params) {
            return "The link will appear in the chat after processing. It'll take some time.";
        },
        'cloud-recording-owner-tip': function (params) {
            return 'Find the link in the meeting chat and in your email';
        },
        'cloud-recording-owner-tip-v2': function (params) {
            return "The link will appear in the chat and in the mailbox after processing. It'll take some time.";
        },
        'conference-limit-error-text': function (params) {
            return 'All new participants go to the waiting room';
        },
        'conference-limit-error-title': function (params) {
            return 'The meeting is full';
        },
        'conference-limit-warning-text': function (params) {
            return "You can't let everyone in";
        },
        'conference-limit-warning-title': function (params) {
            return (
                params['count'] +
                ' ' +
                i18n['tanker']['dynamic']['plural']({
                    count: params['count'],
                    one: 'participant',
                    some: 'participants',
                    many: 'participants',
                }) +
                ' is the limit'
            );
        },
        'participants-search-stub-text': function (params) {
            return 'Try a different spelling';
        },
        'participants-search-stub-title': function (params) {
            return 'No such participant';
        },
        'peers-tab-conference': function (params) {
            return 'In meeting';
        },
        'peers-tab-waiting-room': function (params) {
            return 'Waiting';
        },
        'waiting-room-sort-alfa': function (params) {
            return 'Alphabetically';
        },
        'waiting-room-sort-time': function (params) {
            return 'By the time of joining';
        },
        'waiting-room-stub-text': function (params) {
            return 'Participants waiting to be let in will appear here';
        },
        'waiting-room-stub-title': function (params) {
            return 'Waiting room is empty';
        },
    };

    /* Это автоматически сгенеренный файл. Не редактируйте его самостоятельно. */
    var i18n = i18n || {};

    i18n['telemost'] = i18n['telemost'] || {};

    i18n['telemost']['permission-help'] = {
        header: function (params) {
            return 'Allow Yandex Disk to record the screen \nin the macOS settings';
        },
        message: function (params) {
            return 'Go to Security & Privacy > Screen Recording and select Yandex Disk from the list on the right';
        },
    };

    /* Это автоматически сгенеренный файл. Не редактируйте его самостоятельно. */
    var i18n = i18n || {};

    i18n['telemost'] = i18n['telemost'] || {};

    i18n['telemost']['plan-call'] = {
        calendar: function (params) {
            return 'Calendar';
        },
        'closed-meeting': function (params) {
            return 'This is a private meeting. Ask the organizer to add you to the participant list in Yandex Calendar.';
        },
        'error-planned-broadcast': function (params) {
            return "Couldn't schedule live stream";
        },
        'error-planned-call': function (params) {
            return "Couldn't schedule meeting";
        },
        'go-to-event': function (params) {
            return 'Show';
        },
        'success-planned-broadcast': function (params) {
            return 'Live stream scheduled in Yandex Calendar. All participants will receive a reminder before the live stream. Send the link to viewers manually.';
        },
        'success-planned-call': function (params) {
            return 'Meeting scheduled in Yandex Calendar. \nAll participants will receive \na reminder before the meeting.';
        },
    };

    /* Это автоматически сгенеренный файл. Не редактируйте его самостоятельно. */
    var i18n = i18n || {};

    i18n['telemost'] = i18n['telemost'] || {};

    i18n['telemost']['promo'] = {
        'link-preview': function (params) {
            return 'A messenger with chats and unlimited video calls';
        },
        'mac-app': function (params) {
            return 'Yandex Telemost for macOS';
        },
        'promo-mac-app': function (params) {
            return 'Try Yandex Telemost for macOS';
        },
        'promo-win-app': function (params) {
            return 'Try Yandex Telemost\nfor Windows';
        },
        'win-app': function (params) {
            return 'Yandex Telemost for Windows';
        },
    };

    /* Это автоматически сгенеренный файл. Не редактируйте его самостоятельно. */
    var i18n = i18n || {};

    i18n['telemost'] = i18n['telemost'] || {};

    i18n['telemost']['record'] = {
        'file-name-postfix-chat': function (params) {
            return 'chat';
        },
        'file-name-postfix-record': function (params) {
            return 'recording';
        },
        'file-name-prefix': function (params) {
            return 'Meeting recording';
        },
        'general-record-error': function (params) {
            return 'Recording has stopped. An error occurred while recording.';
        },
        'last-record-download': function (params) {
            return 'Download recording';
        },
        'last-record-download-hint': function (params) {
            return 'Download the recording of the meeting from ' + params['date'];
        },
        'notify-save-chat-history-cancel-button': function (params) {
            return 'Cancel';
        },
        'notify-save-chat-history-save-button': function (params) {
            return 'Save';
        },
        'notify-save-chat-history-text': function (params) {
            return 'Save all messages from the meeting chat?';
        },
        'quota-exceed-error': function (params) {
            return 'There is not enough space on your computer.  The recording has been stopped and saved.';
        },
        'some-participants-recording': function (params) {
            return 'Several participants are recording the meeting to computer';
        },
        'somebody-recording': function (params) {
            return params['name'] + ' is recording the meeting to computer';
        },
        'waiting-download': function (params) {
            return 'Please wait. The meeting recording will soon start downloading.';
        },
    };

    /* Это автоматически сгенеренный файл. Не редактируйте его самостоятельно. */
    var i18n = i18n || {};

    i18n['telemost'] = i18n['telemost'] || {};

    i18n['telemost']['room-agent'] = {
        'alone-screen-text-first-line': function (params) {
            return 'Чтобы посмотреть список команд,';
        },
        'alone-screen-text-second-line': function (params) {
            return 'откройте клавиатуру на планшете и нажмите 1';
        },
        'alone-screen-title-first-line': function (params) {
            return 'Вы на встрече.';
        },
        'alone-screen-title-second-line': function (params) {
            return 'Других участников пока нет';
        },
    };

    /* Это автоматически сгенеренный файл. Не редактируйте его самостоятельно. */
    var i18n = i18n || {};

    i18n['telemost'] = i18n['telemost'] || {};

    i18n['telemost']['settings-v2'] = {
        'account-edit': function (params) {
            return 'Edit';
        },
        'account-log-in': function (params) {
            return 'Log in';
        },
        'account-stub-title': function (params) {
            return 'Log in with Yandex ID';
        },
        'additional-settings-title': function (params) {
            return 'Advanced';
        },
        'bandwidth-effective-4k-codec-badge': function (params) {
            return 'Experimental';
        },
        'bandwidth-effective-4k-codec-label': function (params) {
            return 'Optimize traffic usage during screen sharing';
        },
        'camera-option-back': function (params) {
            return 'Back camera';
        },
        'camera-option-front': function (params) {
            return 'Front camera';
        },
        'default-speaker-device': function (params) {
            return 'Default speaker';
        },
        'develop-do-not-check-desktop-app-existence': function (params) {
            return "Don't check for software";
        },
        'device-is-not-connected': function (params) {
            return 'Not connected';
        },
        'diagnostic-access-device-btn': function (params) {
            return 'How to grant access';
        },
        'diagnostic-access-granting-hint': function (params) {
            return 'Allow access in your computer and browser settings';
        },
        'diagnostic-device-permission-denied': function (params) {
            return 'No access';
        },
        'diagnostic-input-recording-btn': function (params) {
            return 'Recording...';
        },
        'diagnostic-input-start-tooltip': function (params) {
            return 'Record for 5 seconds \nand play immediately';
        },
        'diagnostic-output-start-tooltip': function (params) {
            return 'Play a melody';
        },
        'diagnostic-play-btn': function (params) {
            return 'Test';
        },
        'diagnostic-playing-melody': function (params) {
            return 'Melody playing';
        },
        'diagnostic-playing-record': function (params) {
            return 'Recording playing';
        },
        'diagnostic-record-btn': function (params) {
            return 'Test';
        },
        'diagnostic-stop-playing-btn': function (params) {
            return 'Stop';
        },
        'diagnostic-stop-record-btn': function (params) {
            return 'Stop';
        },
        'diagnostics-bitrate': function (params) {
            return 'Bitrate';
        },
        'diagnostics-cpu': function (params) {
            return 'CPU';
        },
        'diagnostics-mos': function (params) {
            return 'MOS';
        },
        'diagnostics-packets-lost': function (params) {
            return 'Packet loss';
        },
        'diagnostics-rtt': function (params) {
            return 'RTT';
        },
        'feedback-form-description-placeholder': function (params) {
            return 'Tell us what happened in as much detail as possible';
        },
        'feedback-form-mail-error': function (params) {
            return 'Make sure there are no typos';
        },
        'feedback-form-mail-placeholder': function (params) {
            return 'Email';
        },
        'feedback-form-submit': function (params) {
            return 'Send';
        },
        'hide-participants-video-description': function (params) {
            return 'Reduces network load';
        },
        'hide-participants-video-label': function (params) {
            return "Hide participants' video streams";
        },
        'kilobits-short': function (params) {
            return 'kbps';
        },
        'matrix-info-could-not-load': function (params) {
            return 'Информация не загрузилась';
        },
        'meeting-summarization': function (params) {
            return 'Meeting summary';
        },
        'meeting-summarization-v2': function (params) {
            return 'Summary from Alice Pro';
        },
        'menu-item-account': function (params) {
            return 'Account';
        },
        'menu-item-develop': function (params) {
            return 'Development';
        },
        'menu-item-diagnostics': function (params) {
            return 'Diagnostics';
        },
        'menu-item-help': function (params) {
            return 'Help and support';
        },
        'menu-item-permissions': function (params) {
            return 'Participant permissions';
        },
        'menu-item-sound': function (params) {
            return 'Sound';
        },
        'menu-item-theme': function (params) {
            return 'Appearance';
        },
        'menu-item-video': function (params) {
            return 'Video';
        },
        'menu-item-virtual-background': function (params) {
            return 'Meeting background';
        },
        'milliseconds-short': function (params) {
            return 'ms';
        },
        'mos-quality-excellent': function (params) {
            return 'Excellent';
        },
        'mos-quality-good': function (params) {
            return 'Good';
        },
        'mos-quality-poor': function (params) {
            return 'Poor';
        },
        'permission-ban-cloud-recording': function (params) {
            return 'Record the meeting to Yandex Disk';
        },
        'permission-ban-recording': function (params) {
            return 'Record the meeting to computer';
        },
        'permission-ban-summarization': function (params) {
            return 'Summarize the meeting with YandexGPT';
        },
        'permission-ban-summarization-v2': function (params) {
            return 'Summarize the meeting with Alice Pro';
        },
        'permissions-description': function (params) {
            return 'Co-hosts always have these permissions';
        },
        'permissions-description-v2': function (params) {
            return 'Organization admin manages co-host permissions.';
        },
        'permissions-extended-apply': function (params) {
            return 'Применить';
        },
        'permissions-extended-by-default': function (params) {
            return 'Настройки по умолчанию';
        },
        'permissions-extended-by-default-return': function (params) {
            return 'Вернуть';
        },
        'permissions-extended-cancel': function (params) {
            return 'Сбросить';
        },
        'permissions-extended-header': function (params) {
            return 'Права на этой встрече';
        },
        'permissions-extended-reset-modal-cancel': function (params) {
            return 'Не сбрасывать';
        },
        'permissions-extended-reset-modal-confirm': function (params) {
            return 'Сбросить';
        },
        'permissions-extended-reset-modal-description': function (params) {
            return 'Права на встрече останутся прежними';
        },
        'permissions-extended-reset-title': function (params) {
            return 'Сбросить изменения?';
        },
        'permissions-extended-return-to-default-modal-cancel': function (params) {
            return 'Отменить';
        },
        'permissions-extended-return-to-default-modal-confirm': function (params) {
            return 'Вернуть';
        },
        'permissions-extended-return-to-default-modal-description': function (params) {
            return 'Права изменятся на этой встрече. В созданных раньше встречах — не изменятся';
        },
        'permissions-extended-return-to-default-modal-title': function (params) {
            return 'Вернуть настройки прав по умолчанию?';
        },
        'permissions-group-camera': function (params) {
            return 'Камера';
        },
        'permissions-group-close-room': function (params) {
            return 'Завершение встречи';
        },
        'permissions-group-cloud-recording': function (params) {
            return 'Запись встречи на Яндекс Диск';
        },
        'permissions-group-conference-permissions': function (params) {
            return 'Права на этой встрече';
        },
        'permissions-group-desktop': function (params) {
            return 'Демонстрация экрана';
        },
        'permissions-group-microphone': function (params) {
            return 'Микрофон';
        },
        'permissions-group-recording': function (params) {
            return 'Запись встречи на компьютер';
        },
        'permissions-group-summarization': function (params) {
            return 'Конспект встречи';
        },
        'permissions-group-summarization-v2': function (params) {
            return 'Summary from Alice Pro';
        },
        'permissions-group-waiting-room': function (params) {
            return 'Комната ожидания';
        },
        'permissions-header': function (params) {
            return 'Participant permissions for this meeting';
        },
        'receive-calendar-summary-on-mail': function (params) {
            return 'Get the summary by email when invited via Yandex Calendar';
        },
        'receive-summary-on-mail': function (params) {
            return 'Receive the meeting summary by email';
        },
        'receive-summary-on-mail-v2': function (params) {
            return 'Get the summary by email when attending the meeting during summarization';
        },
        'reload-matrix': function (params) {
            return 'Обновить';
        },
        'role-permission-access-level-edit': function (params) {
            return 'Настраивать комнату ожидания\n';
        },
        'role-permission-admit': function (params) {
            return 'Впускать на встречу тех, кто в комнате ожидания\n';
        },
        'role-permission-calendar-summarization-receive': function (params) {
            return 'Получать конспект на почту, если приглашён в Яндекс Календаре';
        },
        'role-permission-camera': function (params) {
            return 'Включать камеру';
        },
        'role-permission-camera-ban': function (params) {
            return 'Запрещать всем включать камеры';
        },
        'role-permission-camera-mute': function (params) {
            return 'Выключать камеры всем';
        },
        'role-permission-camera-unban-self': function (params) {
            return 'Снимать с себя запрет на включение камеры';
        },
        'role-permission-close-room': function (params) {
            return 'Завершать встречу для всех';
        },
        'role-permission-cloud-recording': function (params) {
            return 'Запускать и останавливать запись';
        },
        'role-permission-conference-permissions-edit-matrix': function (params) {
            return 'Менять права на этой встрече';
        },
        'role-permission-desktop': function (params) {
            return 'Запускать демонстрацию экрана';
        },
        'role-permission-desktop-mute': function (params) {
            return 'Останавливать чужую демонстрацию';
        },
        'role-permission-desktop-override': function (params) {
            return 'Запускать демонстрацию вместо идущей';
        },
        'role-permission-desktop-unban-self': function (params) {
            return 'Снимать с себя запрет на демонстрацию экрана';
        },
        'role-permission-microphone': function (params) {
            return 'Включать микрофон\n';
        },
        'role-permission-microphone-ban': function (params) {
            return 'Запрещать всем включать микрофоны\n';
        },
        'role-permission-microphone-mute': function (params) {
            return 'Выключать микрофоны всем';
        },
        'role-permission-microphone-unban-self': function (params) {
            return 'Снимать с себя запрет на включение микрофона';
        },
        'role-permission-recording': function (params) {
            return 'Записывать встречу';
        },
        'role-permission-recording-mute': function (params) {
            return 'Останавливать чужие записи';
        },
        'role-permission-recording-mute-all': function (params) {
            return 'Останавливать чужие записи';
        },
        'role-permission-recording-recording-unban-self': function (params) {
            return 'Снимать с себя запрет на запись встречи';
        },
        'role-permission-summarization': function (params) {
            return 'Start and stop summarization';
        },
        'role-permission-summarization-receive': function (params) {
            return 'Получать конспект на почту, если был на встрече во время конспектирования\n';
        },
        'role-tab-admin': function (params) {
            return 'Соорганизатор';
        },
        'role-tab-member': function (params) {
            return 'Участник';
        },
        'section-account-title': function (params) {
            return 'Account';
        },
        'section-develop-title': function (params) {
            return 'Development';
        },
        'section-diagnostics-subtitle': function (params) {
            return 'Your connection quality is shown here';
        },
        'section-diagnostics-title': function (params) {
            return 'Diagnostics';
        },
        'section-help-title': function (params) {
            return 'Help and support';
        },
        'section-permissions-extended-title': function (params) {
            return 'Права участников';
        },
        'section-sound-title': function (params) {
            return 'Sound';
        },
        'section-theme-subtitle': function (params) {
            return 'Background for Yandex Telemost, Mail, and Disk';
        },
        'section-theme-title': function (params) {
            return 'Yandex 360 theme';
        },
        'sound-change-not-supported-title': function (params) {
            return "You can't configure sound settings in this browser";
        },
        'sound-join-with-microphone-off': function (params) {
            return 'Join with mic muted';
        },
        'sound-microphone': function (params) {
            return 'Microphone';
        },
        'sound-noise-cancellation': function (params) {
            return 'Noise cancellation';
        },
        'sound-noise-cancellation-auto': function (params) {
            return 'Automatic';
        },
        'sound-noise-cancellation-auto-description': function (params) {
            return 'Adjusts to noise level';
        },
        'sound-noise-cancellation-auto-description-v2': function (params) {
            return 'High to low, depending on the computer load';
        },
        'sound-noise-cancellation-auto-v2': function (params) {
            return 'Adaptive';
        },
        'sound-noise-cancellation-disabled': function (params) {
            return 'Off';
        },
        'sound-noise-cancellation-high': function (params) {
            return 'High';
        },
        'sound-noise-cancellation-high-description': function (params) {
            return 'Background conversations, traffic noise';
        },
        'sound-noise-cancellation-high-description-v2': function (params) {
            return 'Cancels all noise. May impact computer performance.';
        },
        'sound-noise-cancellation-low': function (params) {
            return 'Low';
        },
        'sound-noise-cancellation-low-description': function (params) {
            return 'Keyboard sounds, paper rustling';
        },
        'sound-noise-cancellation-low-description-v2': function (params) {
            return 'Cancels slight noise only.';
        },
        'sound-speaker': function (params) {
            return 'Speaker';
        },
        'support-help-go-to': function (params) {
            return 'Open';
        },
        'support-help-title': function (params) {
            return 'Help';
        },
        'support-report-problem': function (params) {
            return 'Contact';
        },
        'support-title': function (params) {
            return 'Support';
        },
        title: function (params) {
            return 'Settings';
        },
        'unsupported-browser-subtitle': function (params) {
            return (
                'Install ' +
                '<x-link-telemost>' +
                'Yandex Telemost for desktop' +
                '</x-link-telemost>' +
                ' or try ' +
                '<x-link-yabro>' +
                'Yandex Browser' +
                '</x-link-yabro>'
            );
        },
        'video-background-tumbler-label': function (params) {
            return 'Dynamic background';
        },
        'video-camera': function (params) {
            return 'Camera';
        },
        'video-change-not-supported-description': function (params) {
            return (
                'Install ' +
                '<x-link-telemost>' +
                'Yandex Telemost for desktop' +
                '</x-link-telemost>' +
                ' or try ' +
                '<x-link-yabro>' +
                'Yandex Browser' +
                '</x-link-yabro>'
            );
        },
        'video-change-not-supported-title': function (params) {
            return "You can't set up the camera in this browser";
        },
        'video-join-with-camera-off': function (params) {
            return 'Join with camera off';
        },
        'video-show-me': function (params) {
            return 'Self view';
        },
    };

    /* Это автоматически сгенеренный файл. Не редактируйте его самостоятельно. */
    var i18n = i18n || {};

    i18n['telemost'] = i18n['telemost'] || {};

    i18n['telemost']['settings'] = {
        account: function (params) {
            return 'Account';
        },
        camera: function (params) {
            return 'Camera';
        },
        'camera-background-blurred': function (params) {
            return 'Blurred';
        },
        'camera-background-none': function (params) {
            return 'No\nbackground';
        },
        'camera-option-back': function (params) {
            return 'Back camera';
        },
        'camera-option-front': function (params) {
            return 'Front camera';
        },
        'change-avatar': function (params) {
            return 'Change image';
        },
        'change-name-and-avatar': function (params) {
            return 'Change name and image';
        },
        'disclaimer-before-connection': function (params) {
            return 'Disclaimer before connecting';
        },
        'do-not-check-desktop-app-existence': function (params) {
            return "Don't check for software availability";
        },
        'help-and-support': function (params) {
            return 'Help and support';
        },
        'hide-participants-video': function (params) {
            return "Hide participants' video streams";
        },
        'hide-participants-video-description': function (params) {
            return 'To reduce network load';
        },
        'join-with-camera-off': function (params) {
            return 'Join with camera off';
        },
        'join-with-microphone-off': function (params) {
            return 'Join with microphone off';
        },
        login: function (params) {
            return 'Log in to account';
        },
        logout: function (params) {
            return 'Log out of account';
        },
        mic: function (params) {
            return 'Microphone';
        },
        'no-theme': function (params) {
            return 'No theme';
        },
        'noise-cancellation-auto': function (params) {
            return 'Automatic';
        },
        'noise-cancellation-auto-v2': function (params) {
            return 'Adaptive';
        },
        'noise-cancellation-high': function (params) {
            return 'Strong';
        },
        'noise-cancellation-low': function (params) {
            return 'Light';
        },
        'noise-cancellation-title': function (params) {
            return 'Noise cancellation';
        },
        'only-beta-testers': function (params) {
            return 'Only beta testers';
        },
        'permission-ban-cloud-recording': function (params) {
            return 'Record the meeting to Yandex Disk';
        },
        'permission-ban-recording': function (params) {
            return 'Record the meeting to computer';
        },
        'permission-ban-summarization': function (params) {
            return 'Summarize the meeting with YandexGPT';
        },
        'permissions-explanation': function (params) {
            return 'Co-hosts always have all permissions enabled';
        },
        'permissions-header': function (params) {
            return 'Permissions of participants at this meeting';
        },
        'permissions-members': function (params) {
            return 'Participant permissions';
        },
        'receive-summary-on-mail': function (params) {
            return 'Receive a meeting summary by email';
        },
        'same-as-system': function (params) {
            return 'Same as system';
        },
        security: function (params) {
            return 'Security';
        },
        'show-mic-or-camera-on': function (params) {
            return 'Show if the camera and microphone are on';
        },
        'show-my-video': function (params) {
            return 'Show me my video during the meeting';
        },
        sound: function (params) {
            return 'Sound';
        },
        'sound-output': function (params) {
            return 'Sound output';
        },
        support: function (params) {
            return 'Support';
        },
        theme: function (params) {
            return 'Theme';
        },
        'theme-dark-flow': function (params) {
            return 'Dark flow';
        },
        'theme-flow': function (params) {
            return 'Flow';
        },
        'theme-grass': function (params) {
            return 'Grass';
        },
        'theme-new-year': function (params) {
            return 'New Year';
        },
        'theme-title': function (params) {
            return 'Yandex 360 theme';
        },
        title: function (params) {
            return 'Settings';
        },
        'unsupported-camera-change-message': function (params) {
            return (
                "You can't change camera settings in Mozilla Firefox. Try the " +
                '<x-link-telemost>' +
                'Yandex Telemost for desktop' +
                '</x-link-telemost>' +
                ' app or ' +
                '<x-link-yabro>' +
                'Yandex Browser' +
                '</x-link-yabro>' +
                '.'
            );
        },
        'unsupported-microphone-change-message': function (params) {
            return (
                "You can't change sound settings in Mozilla Firefox.\nTry the " +
                '<x-link-telemost>' +
                'Yandex Telemost for desktop' +
                '</x-link-telemost>' +
                ' app or ' +
                '<x-link-yabro>' +
                'Yandex Browser' +
                '</x-link-yabro>' +
                '.'
            );
        },
        'virtual-background': function (params) {
            return 'Virtual background';
        },
    };

    /* Это автоматически сгенеренный файл. Не редактируйте его самостоятельно. */
    var i18n = i18n || {};

    i18n['telemost'] = i18n['telemost'] || {};

    i18n['telemost']['share-screen'] = {
        'full-screen': function (params) {
            return 'Full screen';
        },
        'please-wait-long': function (params) {
            return 'Please wait, everything will be soon';
        },
        screen: function (params) {
            return 'Screen';
        },
        'self-starts-demonstration': function (params) {
            return "You're starting screen sharing";
        },
        'start-demonstration': function (params) {
            return 'Share screen';
        },
        'start-sharing': function (params) {
            return 'Start sharing';
        },
        'stop-demonstration': function (params) {
            return 'Stop sharing';
        },
        'stop-demonstration-2': function (params) {
            return 'Stop sharing';
        },
        'user-starts-demonstration': function (params) {
            return params['name'] + ' has started screen sharing';
        },
        window: function (params) {
            return 'Window';
        },
        'your-screen-shared': function (params) {
            return 'Other meeting participants can see your screen';
        },
    };

    /* Это автоматически сгенеренный файл. Не редактируйте его самостоятельно. */
    var i18n = i18n || {};

    i18n['telemost'] = i18n['telemost'] || {};

    i18n['telemost']['statuses'] = {
        'admins-will-receive-summary': function (params) {
            return 'Co-hosts will receive the summary of the meeting by email';
        },
        'admins-will-receive-summary-update-error': function (params) {
            return "Couldn't change the settings: co-hosts will receive the summary";
        },
        'broadcast-create-error': function (params) {
            return "Couldn't create stream";
        },
        'broadcast-end-error': function (params) {
            return "Couldn't end live stream";
        },
        'broadcast-start-error': function (params) {
            return "Couldn't start stream";
        },
        'broadcast-stop-error': function (params) {
            return "Couldn't pause stream";
        },
        'camera-error': function (params) {
            return "Couldn't enable video.\nThe camera doesn't work or is in use by another app.";
        },
        'camera-permission-denied': function (params) {
            return "Couldn't enable video.\nNo access to the camera.";
        },
        'chat-create-error': function (params) {
            return "Couldn't create chat for video meeting." + params['spacebreak'] + 'Try again later';
        },
        'chat-open-error': function (params) {
            return "Couldn't open video meeting chat." + params['spacebreak'] + 'Try again later';
        },
        'connection-established': function (params) {
            return "You've rejoined the meeting";
        },
        'feedback-sended': function (params) {
            return 'Thank you for helping us improve';
        },
        'how-to-do-it': function (params) {
            return 'How to do it?';
        },
        'how-to-enable-device': function (params) {
            return 'How do I allow access?';
        },
        joining: function (params) {
            return 'Connecting';
        },
        'link-already-copied': function (params) {
            return 'Meeting link already copied \n to clipboard';
        },
        'link-copied': function (params) {
            return 'Link copied to clipboard';
        },
        'microphone-error': function (params) {
            return "Couldn't turn on the microphone.\nIt either doesn't work or is in use by another app.";
        },
        'microphone-permission-denied': function (params) {
            return "Couldn't turn on the microphone.\nAccess to the microphone was denied.";
        },
        'modal-device-error-text-audioinput': function (params) {
            return "Make sure it's connected and selected in the Telemost settings";
        },
        'modal-device-error-text-audioinput-busy': function (params) {
            return 'Close it to turn on the sound, or select another microphone in the settings';
        },
        'modal-device-error-text-audioinput-denied-by-system': function (params) {
            return 'Allow access to the microphone in your OS settings and in the address bar';
        },
        'modal-device-error-text-audioinput-denied-by-user': function (params) {
            return 'Allow microphone access';
        },
        'modal-device-error-text-audioinput-denied-by-user-alternative': function (params) {
            return 'In the browser\'s address bar, click the microphone icon and then "Allow"';
        },
        'modal-device-error-text-not-ready': function (params) {
            return 'Select another device in the Telemost settings or restart your computer and connect again';
        },
        'modal-device-error-text-request': function (params) {
            return "Make sure they're connected and selected in the Telemost settings, not used by other applications, and access is granted to them";
        },
        'modal-device-error-text-request-alternative': function (params) {
            return 'Make sure that the camera is connected and selected in the Telemost settings and that it\'s not used by other applications In the browser\'s address bar, click the camera icon and then "Allow"';
        },
        'modal-device-error-text-videoinput': function (params) {
            return 'Make sure that the camera is connected and selected in the Telemost settings';
        },
        'modal-device-error-text-videoinput-applying': function (params) {
            return 'Make sure that the camera is connected and selected in the Telemost settings, not used by other applications, and access is granted to it';
        },
        'modal-device-error-text-videoinput-applying-alternative': function (params) {
            return 'Make sure that the camera is connected and selected in the Telemost settings and that it\'s not used by other applications In the browser\'s address bar, click the camera icon and then "Allow"';
        },
        'modal-device-error-text-videoinput-busy': function (params) {
            return 'Close it to turn on the video, or select another camera in the settings';
        },
        'modal-device-error-text-videoinput-denied-by-system': function (params) {
            return "Allow access to the camera in the operating system settings and then in the browser's address bar";
        },
        'modal-device-error-text-videoinput-denied-by-user': function (params) {
            return 'Allow camera access';
        },
        'modal-device-error-text-videoinput-denied-by-user-alternative': function (params) {
            return 'In the browser\'s address bar, click the camera icon and then "Allow"';
        },
        'modal-device-error-text-videoinput-overconstrained': function (params) {
            return "The camera doesn't support optimal video resolution. Change it in the settings or turn off the video stream.";
        },
        'modal-device-error-title-audioinput': function (params) {
            return "Couldn't turn on the microphone";
        },
        'modal-device-error-title-audioinput-busy': function (params) {
            return 'The microphone is used by another application';
        },
        'modal-device-error-title-audioinput-sound': function (params) {
            return "Couldn't turn on the sound";
        },
        'modal-device-error-title-not-ready': function (params) {
            return "Couldn't turn on the video or microphone";
        },
        'modal-device-error-title-request': function (params) {
            return "Couldn't turn on the video or microphone";
        },
        'modal-device-error-title-videoinput': function (params) {
            return "Couldn't turn on the video";
        },
        'modal-device-error-title-videoinput-busy': function (params) {
            return 'The camera is used by another application';
        },
        'modal-device-error-title-videoinput-overconstrained': function (params) {
            return 'Poor video quality';
        },
        'network-quality-bad': function (params) {
            return 'You have poor connection';
        },
        'network-quality-hide-video': function (params) {
            return "To improve the sound, hide the participants' video streams";
        },
        'network-quality-show-video': function (params) {
            return "Connection is good now, you can turn on participants' video streams";
        },
        'no-internet': function (params) {
            return 'No internet connection';
        },
        'no-permission-to-close-room': function (params) {
            return 'Не удалось завершить — организатор запретил управлять встречей';
        },
        'notification-broadcast-access-level-organization': function (params) {
            return 'Stream for company employees only ';
        },
        'notification-broadcast-access-level-public': function (params) {
            return 'Stream available for external users';
        },
        'notification-cloud-recording-in-progress': function (params) {
            return 'This meeting is being recorded to Yandex Disk';
        },
        'notification-cloud-recording-start-failed': function (params) {
            return "Couldn't start recording to Yandex Disk";
        },
        'notification-cloud-recording-start-failed-mobile': function (params) {
            return "Couldn't start recording";
        },
        'notification-cloud-recording-stop-failed': function (params) {
            return "Couldn't stop recording to Yandex Disk";
        },
        'notification-cloud-recording-stop-failed-mobile': function (params) {
            return "Couldn't stop recording";
        },
        'notification-cloud-recording-was-stopped': function (params) {
            return 'Recording to Yandex Disk stopped';
        },
        'notification-conference-access-level-organization': function (params) {
            return 'Meeting for company employees only';
        },
        'notification-conference-access-level-public': function (params) {
            return 'Meeting available to external users';
        },
        'notification-conference-access-level-waiting-room-admins': function (params) {
            return 'Waiting room is active for everyone';
        },
        'notification-conference-access-level-waiting-room-organization': function (params) {
            return 'Waiting room is active for external participants';
        },
        'notification-conference-access-level-waiting-room-public': function (params) {
            return 'Waiting room is disabled';
        },
        'notification-noise-cancellation-disabled': function (params) {
            return 'Noise cancellation is turned off';
        },
        'notification-noise-cancellation-enabled': function (params) {
            return 'Noise cancellation is turned on';
        },
        'notification-noise-cancellation-high': function (params) {
            return 'Strong noise cancellation is turned on';
        },
        'notification-noise-cancellation-low': function (params) {
            return 'Light noise cancellation is turned on';
        },
        'notification-summarization-in-progress-for-external': function (params) {
            return 'The meeting is being recorded';
        },
        'notification-summarization-in-progress-v2': function (params) {
            return 'The meeting is being summarized';
        },
        'notification-summarization-no-permission-to-stop': function (params) {
            return 'Не удалось остановить — организатор запретил управлять конспектом';
        },
        'notification-summarization-start-failed-v2': function (params) {
            return "Couldn't start summarizing";
        },
        'notification-summarization-stop-failed-v2': function (params) {
            return "Couldn't stop summarizing";
        },
        'notification-summarization-was-stopped': function (params) {
            return 'Stopped creating summary';
        },
        'open-settings': function (params) {
            return 'Go to settings';
        },
        'organizer-revoked-camera-permission': function (params) {
            return 'Организатор запретил включать камеру';
        },
        'organizer-revoked-desktop-permission': function (params) {
            return 'Организатор запретил делиться экраном';
        },
        'organizer-revoked-micro-permission': function (params) {
            return 'Организатор запретил включать микрофон';
        },
        'organizer-revoked-summarization-permission': function (params) {
            return 'Организатор запретил конспектировать';
        },
        'participants-limit': function (params) {
            return "Couldn't connect to video meeting: participant limit reached";
        },
        'participants-video-hidden': function (params) {
            return "Participants' video streams hidden";
        },
        'participants-video-visible': function (params) {
            return "Participants' video streams restored";
        },
        'participants-will-receive-summary': function (params) {
            return 'All participants will receive the summary of the meeting by email';
        },
        'participants-will-receive-summary-update-error': function (params) {
            return "Couldn't change the settings: all participants will receive the summary";
        },
        'permissions-extended-apply-error': function (params) {
            return 'Не удалось изменить права на встрече';
        },
        'permissions-extended-apply-success': function (params) {
            return 'Права на встрече изменены';
        },
        'permissions-extended-matrix-edit-revoked': function (params) {
            return 'Вы больше не можете менять права на встрече';
        },
        'please-unmute': function (params) {
            return 'You are muted. Unmute the microphone';
        },
        reconnecting: function (params) {
            return 'Reconnecting, something went wrong';
        },
        'restoring-connection': function (params) {
            return 'Restoring the connection';
        },
        'room-was-closed': function (params) {
            return 'The host ended the meeting for everyone';
        },
        'screen-sharing-access-message': function (params) {
            return 'Allow access to the screen in the browser settings';
        },
        'screen-sharing-already-active': function (params) {
            return 'Screen sharing is already active. ';
        },
        'screen-sharing-cancelled-or-denied-message': function (params) {
            return 'The demonstration is canceled, or the browser does not have access to the screen';
        },
        'screen-sharing-error-info-message': function (params) {
            return 'Stop sharing the current screen to start sharing a new one.';
        },
        'screen-sharing-race-message': function (params) {
            return 'Another user started sharing their screen the same time as you did. Try sharing your screen later';
        },
        'summarization-in-progress-admins-will-receive': function (params) {
            return 'The meeting is being summarized. The summary will be emailed to all co-organizers.';
        },
        'summarization-in-progress-participants-will-receive': function (params) {
            return 'The meeting is being summarized. The summary will be emailed to all participants.';
        },
        'summarization-no-permission-to-start': function (params) {
            return 'Only a co-host can start summarization';
        },
        'to-settings': function (params) {
            return 'Settings';
        },
        'turn-on': function (params) {
            return 'Unmute';
        },
        'user-broadcasting': function (params) {
            return params['name'] + ' is\nstreaming the meeting';
        },
        'user-was-kicked': function (params) {
            return 'You were removed from the meeting';
        },
        'video-loading': function (params) {
            return 'Loading video';
        },
        'waiting-room-admit-all-error': function (params) {
            return "Couldn't let in the participants from the waiting room";
        },
        'waiting-room-admit-error': function (params) {
            return "Couldn't let in the participant";
        },
        'waiting-room-new-peer': function (params) {
            return params['displayName'] + ' is in the waiting room';
        },
        'waiting-room-new-peers': function (params) {
            return 'Participants in waiting room';
        },
    };

    /* Это автоматически сгенеренный файл. Не редактируйте его самостоятельно. */
    var i18n = i18n || {};

    i18n['telemost'] = i18n['telemost'] || {};

    i18n['telemost']['summarization'] = {
        'feedback-chat-section-description': function (params) {
            return 'Write reviews to help us make summaries more accurate and learn about the newest updates.';
        },
        'feedback-chat-section-join': function (params) {
            return 'Join chat';
        },
        'feedback-chat-section-title': function (params) {
            return "We'd love to hear more from you";
        },
        'feedback-content': function (params) {
            return 'It will help our AI to learn faster.';
        },
        'feedback-content-v2': function (params) {
            return 'Alice Pro learns faster this way';
        },
        'feedback-header': function (params) {
            return 'Thanks for the feedback!';
        },
        'send-summary-to-participants': function (params) {
            return 'Send the summary to all participants';
        },
        'start-dialog-content': function (params) {
            return 'The summary will be sent to the meeting chat and emailed to the Yandex users who were in the meeting while YandexGPT was active';
        },
        'start-dialog-content-v2': function (params) {
            return 'The co-hosts present at the meeting at that time will receive the summary by email';
        },
        'start-dialog-deny': function (params) {
            return 'No';
        },
        'start-dialog-submit': function (params) {
            return 'Yes';
        },
        'start-dialog-title': function (params) {
            return 'Summarize the meeting with YandexGPT?';
        },
        'start-dialog-title-v2': function (params) {
            return 'Summarize the meeting?';
        },
        'stop-dialog-change-participants-permissions': function (params) {
            return (
                'You can change participant permissions in the ' +
                '<x-link-settings>' +
                'settings' +
                '</x-link-settings>' +
                '.'
            );
        },
        'stop-dialog-content': function (params) {
            return 'Summarizing will stop for all meeting participants';
        },
        'stop-dialog-content-receive-by-mail': function (params) {
            return 'The summary will be emailed to:';
        },
        'stop-dialog-content-v2': function (params) {
            return 'Summarizing will stop for all meeting participants. Co-hosts will receive the summary by email.';
        },
        'stop-dialog-content-v3': function (params) {
            return 'Summarizing will stop for all participants.';
        },
        'stop-dialog-content_admins_bsr': function (params) {
            return 'The summary will be emailed to co-hosts if they were present at the meeting when it was summarized or if they were invited in Yandex Calendar';
        },
        'stop-dialog-content_admins_bsr_members_bsr': function (params) {
            return 'The summary will be emailed to co-hosts and participants if they were present at the meeting when it was summarized or if they were invited in Yandex Calendar';
        },
        'stop-dialog-content_admins_bsr_members_csr': function (params) {
            return '— Co-hosts if they were present at the meeting when it was summarized or if they were invited in Yandex Calendar\n— Participants invited in Yandex Calendar';
        },
        'stop-dialog-content_admins_bsr_members_sr': function (params) {
            return '— Co-hosts if they were present at the meeting when it was summarized or if they were invited in Yandex Calendar\n— Participants who were present at the meeting when it was summarized';
        },
        'stop-dialog-content_admins_csr': function (params) {
            return 'The summary will be emailed to co-hosts invited in Yandex Calendar';
        },
        'stop-dialog-content_admins_csr_members_bsr': function (params) {
            return '— Co-hosts invited in Yandex Calendar\n— Participants if they were present at the meeting when it was summarized or if they were invited in Yandex Calendar';
        },
        'stop-dialog-content_admins_csr_members_csr': function (params) {
            return 'The summary will be emailed to co-hosts and participants invited in Yandex Calendar';
        },
        'stop-dialog-content_admins_csr_members_sr': function (params) {
            return '— Co-hosts invited in Yandex Calendar\n— Participants who were present at the meeting when it was summarized';
        },
        'stop-dialog-content_admins_sr': function (params) {
            return 'The summary will be emailed to co-hosts who were present at the meeting when it was summarized';
        },
        'stop-dialog-content_admins_sr_members_bsr': function (params) {
            return '— Co-hosts who were present at the meeting when it was summarized\n— Participants if they were present at the meeting when it was summarized or if they were invited in Yandex Calendar';
        },
        'stop-dialog-content_admins_sr_members_csr': function (params) {
            return '— Co-hosts who were present at the meeting when it was summarized\n— Participants invited in Yandex Calendar';
        },
        'stop-dialog-content_admins_sr_members_sr': function (params) {
            return 'The summary will be emailed to co-hosts and participants who were present at the meeting when it was summarized';
        },
        'stop-dialog-content_members_bsr': function (params) {
            return "— The summary will be emailed to participants if they were present at the meeting when it was summarized or if they were invited in Yandex Calendar\n— The host and co-hosts won't get the summary";
        },
        'stop-dialog-content_members_csr': function (params) {
            return "— The summary will be emailed to participants invited in Yandex Calendar\n— The host and co-hosts won't get the summary";
        },
        'stop-dialog-content_members_sr': function (params) {
            return "— The summary will be emailed to participants who were present at the meeting when it was summarized\n— The host and co-hosts won't get the summary";
        },
        'stop-dialog-content_nobody-receive': function (params) {
            return 'Nobody will get the summary. Ask your organization admin to change the permissions of the host and co-hosts';
        },
        'stop-dialog-content_owner_csr': function (params) {
            return 'The summary will be emailed to the host';
        },
        'stop-dialog-content_owner_csr_admins_bsr': function (params) {
            return '— The host\n— Co-hosts if they were present at the meeting when it was summarized or if they were invited in Yandex Calendar';
        },
        'stop-dialog-content_owner_csr_admins_bsr_members_bsr': function (params) {
            return 'The summary will be emailed to everyone who was present at the meeting when it was summarized and everyone invited in Yandex Calendar';
        },
        'stop-dialog-content_owner_csr_admins_bsr_members_csr': function (params) {
            return '— Everyone invited in Yandex Calendar\n— Co-hosts who were present at the meeting when it was summarized';
        },
        'stop-dialog-content_owner_csr_admins_bsr_members_sr': function (params) {
            return '— The host \n— Co-hosts if they were present at the meeting when it was summarized or if they were invited in Yandex Calendar\n— Participants who were present at the meeting when it was summarized';
        },
        'stop-dialog-content_owner_csr_admins_csr': function (params) {
            return 'The summary will be emailed to the host and co-hosts invited in Yandex Calendar';
        },
        'stop-dialog-content_owner_csr_admins_csr_members_bsr': function (params) {
            return '— Everyone invited in Yandex Calendar\n— Participants who were present at the meeting when it was summarized';
        },
        'stop-dialog-content_owner_csr_admins_csr_members_csr': function (params) {
            return 'The summary will be emailed to everyone invited in Yandex Calendar';
        },
        'stop-dialog-content_owner_csr_admins_csr_members_sr': function (params) {
            return '— The host\n— Co-hosts invited in Yandex Calendar\n— Participants who were present at the meeting when it was summarized';
        },
        'stop-dialog-content_owner_csr_admins_sr': function (params) {
            return '— The host\n— Co-hosts who were present at the meeting when it was summarized';
        },
        'stop-dialog-content_owner_csr_admins_sr_members_bsr': function (params) {
            return '— The host\n— Co-hosts who were present at the meeting when it was summarized\n— Participants if they were present at the meeting when it was summarized or if they were invited in Yandex Calendar';
        },
        'stop-dialog-content_owner_csr_admins_sr_members_csr': function (params) {
            return '— The host\n— Co-hosts who were present at the meeting when it was summarized\n— Participants invited in Yandex Calendar';
        },
        'stop-dialog-content_owner_csr_admins_sr_members_sr': function (params) {
            return '— The host\n— Co-hosts and participants who were present at the meeting when it was summarized';
        },
        'stop-dialog-content_owner_csr_members_bsr': function (params) {
            return '— The host\n— Participants if they were present at the meeting when it was summarized or if they were invited in Yandex Calendar';
        },
        'stop-dialog-content_owner_csr_members_csr': function (params) {
            return 'The summary will be emailed to the host and participants invited in Yandex Calendar';
        },
        'stop-dialog-content_owner_csr_members_sr': function (params) {
            return '— The host\n— Participants who were present at the meeting when it was summarized';
        },
        'stop-dialog-content_owner_sr': function (params) {
            return 'The summary will be emailed to the host if they were present at the meeting when it was summarized';
        },
        'stop-dialog-content_owner_sr_admins_bsr': function (params) {
            return '— The host if they were present at the meeting when it was summarized\n— Co-hosts if they were present at the meeting when it was summarized or if they were invited in Yandex Calendar';
        },
        'stop-dialog-content_owner_sr_admins_bsr_members_bsr': function (params) {
            return '— Everyone who was present at the meeting when it was summarized\n— Co-hosts and participants invited in Yandex Calendar';
        },
        'stop-dialog-content_owner_sr_admins_bsr_members_csr': function (params) {
            return '— Host and co-hosts who were present at the meeting when it was summarized\n— Co-hosts and participants invited in Yandex Calendar';
        },
        'stop-dialog-content_owner_sr_admins_bsr_members_sr': function (params) {
            return '— Everyone who was present at the meeting when it was summarized\n— Co-hosts invited in Yandex Calendar';
        },
        'stop-dialog-content_owner_sr_admins_csr': function (params) {
            return '— The host if they were present at the meeting when it was summarized\n— Co-hosts invited in Yandex Calendar';
        },
        'stop-dialog-content_owner_sr_admins_csr_members_bsr': function (params) {
            return '— The host and participants who were present at the meeting when it was summarized\n— Co-hosts and participants invited in Yandex Calendar';
        },
        'stop-dialog-content_owner_sr_admins_csr_members_csr': function (params) {
            return '— The host if they were present at the meeting when it was summarized\n— Co-hosts and participants invited in Yandex Calendar';
        },
        'stop-dialog-content_owner_sr_admins_csr_members_sr': function (params) {
            return '— The host and participants who were present at the meeting when it was summarized\n— Co-hosts invited in Yandex Calendar';
        },
        'stop-dialog-content_owner_sr_admins_sr': function (params) {
            return 'The summary will be emailed to the host and co-hosts who were present at the meeting when it was summarized';
        },
        'stop-dialog-content_owner_sr_admins_sr_members_bsr': function (params) {
            return '— Everyone who was present at the meeting when it was summarized\n— Participants invited in Yandex Calendar';
        },
        'stop-dialog-content_owner_sr_admins_sr_members_csr': function (params) {
            return '— The host and co-hosts who were present at the meeting when it was summarized\n— Participants invited in Yandex Calendar';
        },
        'stop-dialog-content_owner_sr_admins_sr_members_sr': function (params) {
            return 'The summary will be emailed to everyone who was present at the meeting when it was summarized';
        },
        'stop-dialog-content_owner_sr_members_bsr': function (params) {
            return '— The host if they were present at the meeting when it was summarized\n— Participants if they were present at the meeting when it was summarized or if they were invited in Yandex Calendar';
        },
        'stop-dialog-content_owner_sr_members_csr': function (params) {
            return '— The host if they were present at the meeting when it was summarized\n— Participants invited in Yandex Calendar';
        },
        'stop-dialog-content_owner_sr_members_sr': function (params) {
            return 'The summary will be emailed to the host and participants who were present at the meeting when it was summarized';
        },
        'stop-dialog-deny': function (params) {
            return 'No, continue';
        },
        'stop-dialog-deny-v2': function (params) {
            return 'No';
        },
        'stop-dialog-submit': function (params) {
            return 'Stop';
        },
        'stop-dialog-submit-v2': function (params) {
            return 'Yes';
        },
        'stop-dialog-title': function (params) {
            return 'Stop creating summary?';
        },
        'stop-dialog-title-v2': function (params) {
            return 'Stop summarizing?';
        },
        'welcome-dialog-content': function (params) {
            return "The Yandex users will receive the summary by email. It won't be emailed to external participants.";
        },
        'welcome-dialog-content-v2': function (params) {
            return "Co-hosts of the meeting can start the summarization. They'll receive the summary and transcript by email.";
        },
        'welcome-dialog-content-v3': function (params) {
            return 'The email will include the complete transcript, a summary of key agreements, and the main topics discussed.';
        },
        'welcome-dialog-submit': function (params) {
            return 'Great';
        },
        'welcome-dialog-title': function (params) {
            return 'YandexGPT will create a meeting summary ';
        },
        'welcome-dialog-title-v2': function (params) {
            return 'AI will create a meeting summary ';
        },
        'welcome-dialog-title-v3': function (params) {
            return 'Alice Pro will summarize the meeting';
        },
    };

    /* Это автоматически сгенеренный файл. Не редактируйте его самостоятельно. */
    var i18n = i18n || {};

    i18n['telemost'] = i18n['telemost'] || {};

    i18n['telemost']['telemessenger-placeholder'] = {
        'continue-in-browser': function (params) {
            return 'Continue in browser';
        },
        'install-telemost': function (params) {
            return 'Download Telemost';
        },
        'install-telemost-motivation-text': function (params) {
            return 'Download the app to chat and make video calls';
        },
        'you-have-been-invited-to-telemost-chat': function (params) {
            return "You've been invited to a chat\nin Yandex Telemost";
        },
    };

    /* Это автоматически сгенеренный файл. Не редактируйте его самостоятельно. */
    var i18n = i18n || {};

    i18n['telemost'] = i18n['telemost'] || {};

    i18n['telemost']['toolbar'] = {
        'access-level-organization': function (params) {
            return 'Lock for external users';
        },
        'access-level-public': function (params) {
            return 'Unlock for everyone';
        },
        'broadcast-continue': function (params) {
            return 'Resume live stream';
        },
        'broadcast-continue-v2': function (params) {
            return 'Resume live stream';
        },
        'broadcast-copy-link': function (params) {
            return 'Link for viewers';
        },
        'broadcast-end': function (params) {
            return 'End live stream';
        },
        'broadcast-end-confirm-modal-cancel': function (params) {
            return 'Cancel';
        },
        'broadcast-end-confirm-modal-confirm': function (params) {
            return 'End';
        },
        'broadcast-end-confirm-modal-content': function (params) {
            return 'Viewers will no longer see the meeting, but participants can continue the conversation';
        },
        'broadcast-end-confirm-modal-header': function (params) {
            return 'End the live stream?';
        },
        'broadcast-ending': function (params) {
            return 'Ending...';
        },
        'broadcast-not-on-air': function (params) {
            return 'Not live';
        },
        'broadcast-not-on-air-tooltip': function (params) {
            return 'Click here to start the live stream or copy the link for viewers';
        },
        'broadcast-on-air': function (params) {
            return 'Live';
        },
        'broadcast-on-air-tooltip': function (params) {
            return 'Click here to pause the live stream or copy the link for viewers';
        },
        'broadcast-paused': function (params) {
            return 'Pause';
        },
        'broadcast-paused-tooltip': function (params) {
            return 'Click here to resume the live stream or copy the link for viewers';
        },
        'broadcast-starting': function (params) {
            return 'Launching...';
        },
        'broadcast-starting-tooltip': function (params) {
            return 'The live stream is starting. This will take about a minute';
        },
        'broadcast-viewers-count': function (params) {
            return (
                params['count'] +
                ' ' +
                i18n['tanker']['dynamic']['plural']({
                    count: params['count'],
                    one: 'viewer',
                    some: 'viewers',
                    many: 'viewers',
                })
            );
        },
        'chat-button-alt-title': function (params) {
            return 'Open chat';
        },
        'chat-button-title': function (params) {
            return 'Chat';
        },
        'close-toolbar': function (params) {
            return 'Close section';
        },
        'cloud-recording-prepare': function (params) {
            return 'Preparing to record...';
        },
        'cloud-recording-start': function (params) {
            return 'Record to Yandex Disk';
        },
        'cloud-recording-stop': function (params) {
            return 'Stop recording to Yandex Disk';
        },
        'continue-broadcast': function (params) {
            return 'Resume live stream';
        },
        'create-broadcast': function (params) {
            return 'Create stream';
        },
        'end-call': function (params) {
            return 'Leave meeting';
        },
        'end-call-alt': function (params) {
            return 'Leave meeting';
        },
        'end-call-for-everyone': function (params) {
            return 'End meeting for everyone';
        },
        'gallery-view': function (params) {
            return 'Gallery view';
        },
        'hand-down': function (params) {
            return 'Hand down';
        },
        'hand-up': function (params) {
            return 'Raise hand';
        },
        'local-recording-start': function (params) {
            return 'Record to computer';
        },
        'local-recording-stop': function (params) {
            return 'Stop recording to computer';
        },
        'more-option-turn-off-camera': function (params) {
            return 'Turn off video';
        },
        'more-option-turn-off-mic': function (params) {
            return 'Turn off microphone';
        },
        'more-option-turn-on-camera': function (params) {
            return 'Turn on video';
        },
        'more-popup-alt-title': function (params) {
            return 'More';
        },
        'more-popup-option-settings': function (params) {
            return 'Settings';
        },
        'open-settings': function (params) {
            return 'Open settings';
        },
        'organizer-revoked-camera-permission': function (params) {
            return 'Организатор запретил включать камеру';
        },
        'organizer-revoked-desktop-permission': function (params) {
            return 'Организатор запретил делиться экраном';
        },
        'organizer-revoked-micro-permission': function (params) {
            return 'Организатор запретил включать микрофон';
        },
        'organizer-revoked-summarization-permission': function (params) {
            return 'Организатор запретил запускать конспект';
        },
        'participants-button-title': function (params) {
            return 'Participants';
        },
        'presenter-view': function (params) {
            return 'Speaker view';
        },
        'quit-call-confirm-modal-confirm': function (params) {
            return 'Leave';
        },
        'quit-call-confirm-modal-content': function (params) {
            return 'The live stream will end';
        },
        'quit-call-confirm-modal-header': function (params) {
            return 'Leave the meeting?';
        },
        'recording-in-process': function (params) {
            return 'Recording';
        },
        'recording-place-cloud': function (params) {
            return 'Yandex Disk';
        },
        'recording-place-local': function (params) {
            return 'Computer';
        },
        'recording-stop': function (params) {
            return 'Stop';
        },
        'share-desktop-button-started-title': function (params) {
            return 'Screen sharing on';
        },
        'share-desktop-button-stop-title': function (params) {
            return 'Stop';
        },
        'share-desktop-button-title': function (params) {
            return 'Share screen';
        },
        'show-limitation-popup-description': function (params) {
            return 'Only the first 30 minutes will be recorded. You can record the whole meeting using the desktop app.';
        },
        'show-limitation-popup-download': function (params) {
            return 'Install app';
        },
        'start-broadcast': function (params) {
            return 'Start live stream';
        },
        'stop-broadcast': function (params) {
            return 'Pause live stream';
        },
        'summarization-mail-for-admins': function (params) {
            return 'Co-hosts will have the summary';
        },
        'summarization-mail-for-participants': function (params) {
            return 'The summary will be sent by email';
        },
        'summarization-no-permission-to-start': function (params) {
            return 'Only a co-host can start summarization';
        },
        'summarization-prepare': function (params) {
            return 'Preparing summary...';
        },
        'summarization-running': function (params) {
            return 'Summarizing';
        },
        'summarization-start': function (params) {
            return 'Summarize with YandexGPT';
        },
        'summarization-start-v2': function (params) {
            return 'Summarize with Alice Pro';
        },
        'summarization-starting': function (params) {
            return 'Launching...';
        },
        'summarization-starting-extended': function (params) {
            return 'Starting summarization...';
        },
        'summarization-stop': function (params) {
            return 'Stop creating summary';
        },
        'summarization-stop-extended': function (params) {
            return 'Stop summarizing';
        },
        'summarization-stop-v2': function (params) {
            return 'Stop';
        },
        'turn-off-camera': function (params) {
            return 'Turn off camera';
        },
        'turn-off-mic': function (params) {
            return 'Turn off microphone';
        },
        'turn-on-camera': function (params) {
            return 'Turn on camera';
        },
        'turn-on-mic': function (params) {
            return 'Turn on microphone';
        },
    };

    if (module && module.exports) {
        module.exports = i18n;
    } else {
        window.i18n = window.i18n || {};
        window.i18n['en'] = i18n;
    }
})();
